import { CdkAccordionModule } from '@angular/cdk/accordion';
import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, ViewChildren, HostListener, QueryList, WritableSignal, Renderer2 } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormsModule, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialog } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { MatSidenav, MatSidenavContainer, MatSidenavContent, MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UserPromptService } from '../../services/user-prompt.service';
import { RatingFeedbackComponent } from '../../rating-feedback/rating-feedback.component';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatStepper, MatStepperModule, MatStepperPrevious, MatStep, MatStepperNext } from '@angular/material/stepper';
import { SaveSuccessComponent } from '../../save-success/save-success.component';
import { PromtUserService } from '../../services/prompt-user.service';
import { RejectPromptComponent } from '../../reject-prompt/reject-prompt.component';
import { FavComponentDailogComponent } from '../../dailog/fav-component-dailog/fav-component-dailog.component';
import { DashboardService } from '../../services/shared/dashboard.service';
import { PromptCreateService } from '../../services/prompt-create.service';
import { OnUpdateComponent } from '../../on-update/on-update.component';
import { ButtonComponent } from '../common/components/button/button.component';
import { ApprovePromptComponent } from '../common/approve-prompt/approve-prompt.component';
import { MatTabsModule } from '@angular/material/tabs';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { OnSaveComponent } from '../../on-save/on-save.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MatTabGroup } from '@angular/material/tabs';
import { NgZone, signal } from '@angular/core';
import { SnackBarComponent } from '../common/components/snack-bar/snack-bar.component';
import { marked } from 'marked';
import { DateTimeFormatterPipe } from '../common/pipes/date-time-formatter.pipe';
import { RemoveFavoriteComponent } from '../../remove-favorite/remove-favorite.component';
import { ModifiedChangesComponent } from '../../modified-changes/modified-changes.component';
import { ErrorNotficationComponent } from '../../error-notfication/error-notfication.component';
import { ContenteditableDirective } from '../../directives/contenteditable.directive';
import { LoaderComponent } from '../common/components/loader/loader.component';
import { ChatHistorySelectionComponent } from '../../chat-history-selection/chat-history-selection.component';
import { catchError, finalize, of } from 'rxjs';
import { PollingDialogComponent } from '../polling-dialog/polling-dialog.component';
import { PdfViewerComponent } from '../pdf-viewer/pdf-viewer.component';
import { ChatViewerComponent } from '../chat-viewer/chat-viewer.component';

@Component({
  selector: 'app-user-prompt',
  standalone: true,
  imports: [
    MatCardModule,
    CommonModule,
    CdkAccordionModule,
    MatSidenav,
    MatSidenavContainer,
    MatSidenavContent,
    MatSidenavModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    MatInputModule,
    MatTabsModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatStepperModule,
    MatStepperPrevious,
    MatStepper,
    MatStep,
    MatStepperNext,
    ReactiveFormsModule,
    FormsModule,
    ButtonComponent,
    DragDropModule,
    MatTabGroup,
    DateTimeFormatterPipe,
    MatTooltipModule,
    ContenteditableDirective,
    LoaderComponent,
    PdfViewerComponent,
    ChatViewerComponent
  ],
  templateUrl: './user-prompt.component.html',
  styleUrl: './user-prompt.component.scss'
})
export class UserpromptComponent implements OnInit {
  @ViewChild('stepper') stepper!: MatStepper;
  @ViewChild('pageInput') pageInput!: HTMLInputElement;
  sortOptions = ['Most Used', 'All', 'Favorite'];
  disableNext: boolean = true;
  isNextClick: boolean = false;
  style2: boolean = false;
  step1!: FormGroup;
  step2!: FormGroup;
  step3!: FormGroup;
  promptUserDetails: any;
  allcategory: any;
  model: any;
  allPrompt: any;
  creatore: any;
  fromSearchData: any;
  gptScore: any;
  modal: any;
  attachments: any[] = [];
  categories: any = [];
  createdBy: any = [];
  promptCreatedBy: any = '';
  promptCategory: any = '';
  showDefaultType: boolean = false;
  isPrevioustClick: boolean = false;
  currentStepIndex: number = 0;
  savedData: any;
  selectedLibrary: any;
  isEditMode: boolean = false;
  promptSubcategory: any = '';
  userid: any;
  user_role: any;
  isfavourite: any;
  promptId: number = 0;
  promptText: string = '';
  public files: any[] = [];
  myForm: FormGroup;
  tabs: { label: string, myForm: FormGroup }[] = [];
  perminentAttachments: any[] = [];
  chatId: any;
  messages: any = [];
  msg:any=[];
  typingInterval: any;
  urlParams: any;
  enableSubmit: boolean = true;
  isMultiText: boolean = false;
  shrinkFooter: boolean = false;
  isPromptInserting: boolean = false;
  enableChatPrompt: boolean = false;
  typingInProgress: boolean = false;
  prompt_id: any;
  permanentAttachments: any[] = [];
  promptResponse: any;
  category_id: any = [];
  sub_category_id: any = [];
  subcategories: any;
  createdbyarray: any;
  onMyFavouriteClick: boolean = false;
  onMyPromptsClick: boolean = false;
  status: any = [];
  updatedCategories: any = [];
  promptDetailsId: any = null;
  @ViewChild('chatContainer') chatContainer!: ElementRef;
  @ViewChild('mainScroll') mainScrollContainer!: ElementRef;
  @ViewChild('otherAttachmentsNextContainer') otherAttachmentsNextContainer!: ElementRef;
  otherAttachments: any;
  title: any;
  promptDetails = new FormControl();
  description!: string;
  notes!: string;
  disabledelete: boolean = false;
  @ViewChild('tabGroup') tabGroup!: MatTabGroup;
  selectedtab = 0;
  isLast: boolean = false;
  isFirst: boolean = true;
  isSidebarOpen = false;
  expandedState: boolean[] = [];
  chatHistory: any[] = [];
  fileNames: any = [];
  passedFileNames: any = [];
  promptQuestion: string = '';
  projectCode: string = '';
  pdfText: any = [];
  generatingLoadText: string = "Generating...";
  selectedIndex: number = 0;
  isPromptGenerating: boolean = false;
  isExpansion: boolean = false;
  chatHistoryData: any = [];
  noteslist: any = [];
  showNotes: boolean = true;
  timeOutCounterLimit: number = 360;
  laterClickCount: number = 0; // Tracks "Later" clicks
  template_converted:boolean=false;
  attachmentForm: FormGroup;
  attachmentTabs: {attachmentForm: FormGroup}[] = [];
  model_issue:boolean=false;
  feedbackStatus:boolean=false;

  pollingInterval: any;
  currChatId = signal<{chat_id: string, message_id: string}>({chat_id: "", message_id: ""})
  getPromptAnswerLimit:number = 0;
  models = signal<{ id: number, name: string, value: string }[]>([]);
  selectedModelId: { id: number, name: string, value: string } | null = null;

  logged_version_ids: number[] = [];
  promptModified = signal<boolean>(false)
  showUnsavedDataChanges = signal<boolean>(false)
  // safeMessage = signal<SafeHtml>('' as SafeHtml);
  enableRating = signal<boolean>(false)
  showPromptInstruction = false;
  showTooltipInstruction = false;
  showVersionInstruction = true;
  isVariableScrollable = true;
  isLoading: boolean = false;
  activeVarIndex: any = 0;
  activeVarTabIndex: any = 0;
  showTooltip1: boolean = false;
  hideTimeout: any;
  @ViewChildren(MatStep) steps!: QueryList<MatStep>;
  private stepsInitialized = false; // Prevent unnecessary updates
  completedSteps = new Set<number>([]); // Tracks steps where "Run" has been clicked
  isPromptExpansion:boolean = false;
  isExecuted:boolean=false;
  pollingDialogRef: any;
  pollingRunPromptInterval:any;
  isPromptRunning: boolean = false;
  isRevokedRejected: boolean = false;
  promptDataEditedVal: string = "";
  SELECTED_CHAT_HISTORY_ID:string='';
  estimated_time: number = 0.00;

  constructor(private dashboardService: DashboardService, private dialog: MatDialog, private promptUserService: PromtUserService, private promptCreateService: PromptCreateService, private userPromptService: UserPromptService, private dailog: MatDialog, private _snackBar: MatSnackBar, private router: Router, private sanitizer: DomSanitizer,
    private activatedRoute: ActivatedRoute, private fb: FormBuilder, private zone: NgZone, private eRef: ElementRef, private renderer: Renderer2) {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.urlParams = params;
    })

    if (this.urlParams && this.urlParams['role'] === 'creator') {
      this.enableSubmit = false;
    }
    this.myForm = this.fb.group({
      promptDetails: "",
      variables: this.fb.array([]),
      variablesCopy: this.fb.array([]),
      gptQuestion: ""
    });
    this.attachmentForm = this.fb.group({
      otherAttachment: [null],
      permanentAttachments :[null],
    });
  }
  ngOnInit(): void {

    //Issue with commit in development
    // this.promptUserService.currentData.subscribe((data) => {
    //   this.otherAttachments = data;
    // })

    //Reverted code from QA...
    this.promptUserService.currentData.subscribe((data) => {
      this.otherAttachments = data[0]?.name;
    })

    this.userPromptService.changeData(true);


    const urlParams = this.router.url.split('?selected_prompt=');
    const urlParamsData = this.router.url.split('?selectedlibrary=');
    if (urlParamsData && urlParamsData.length > 1) {
      this.selectedLibrary = urlParamsData[1];
    }
    if (urlParams && urlParams.length > 1) {
      this.prompt_id = +urlParams[1]
    }
    //  this.dashboardService.currentData.subscribe((data : number) => {
    //   this.userid = data;
    //   if (this.userid == 1) {
    //     this.user_role = 'admin';
    //   } else if (this.userid == 2) {
    //     this.user_role = 'curator';
    //   } else if (this.userid == 3) {
    //     this.user_role = 'creator';
    //   } else if (this.userid == 4) {
    //     this.user_role = 'user';
    //   }
    // });
    this.user_role = this.dashboardService.user_role
    this.userid = this.dashboardService.user_id;
    this.getPromptDetails();
    this.getAllCate("", this.userid, this.modal, this.category_id, this.sub_category_id, this.createdbyarray, this.onMyFavouriteClick, this.onMyPromptsClick, this.user_role, this.status)
 

    if(this.promptUserService.RhsPanelStatus() == true) {
      this.attachmentTabs = this.promptUserService.attachmentTabs()
     
    }
    this.getModel();
  }
  
  ngAfterViewChecked() {
    if (!this.stepsInitialized && this.steps.length > 0) {
      this.stepsInitialized = true; // Ensure it runs only once
      this.markCompletedSteps();
    }
  }

  markCompletedSteps() {
    this.steps.forEach((step, index) => {
      if (this.completedSteps.has(index)) {
        step.completed = true;
      }
    });
  }

  ngAfterViewInit() {
    this.tags.changes.subscribe(() => {
        this.updateInputOffset();
    });
  }

  getModel() {
    this.dashboardService.getModel().subscribe({
      next: (model) => {
        if(model.status_code == 200) {
          let model_data = model.data.map((item: any) => ({id: item.id, name: item.name, value: item.value}))
          this.models.set(model_data);

          // Set the initial value after updating models
          if(model_data.length > 0) {
            const { model_id, model_name } = this.promptUserDetails?.prompt_details?.[0]?.llm || {};
              // this.selectedModelId = { id: model_id, name: model_name, value: model_name };
              this.selectedModelId=this.models().find(model=>model.id === model_id)?? null;
            
             //this.selectedModelId = model_data[0];
             //const { model_id, model_name } = this.promptUserDetails?.prompt_details?.[0]?.llm || {};
             //this.selectedModelId = { id: model_id, name: model_name, value: model_name };
           
             //this.selectedModelId=this.promptUserDetails?.prompt_details[0]?.llm?.model_id;
            
          }
        }
      },
      error: (err) => { console.log(err) },
      complete: () => {} 
    })
  }

  // Comparison function for `compareWith`
  compareById(model1: { id: number; name: string }, model2: { id: number; name: string }): boolean {
    return model1 && model2 && model1.id === model2.id;
  }

  toggleDropdown(select: MatSelect): void {
    if (select.panelOpen) {
      select.close(); // Close the dropdown if it's open
    } else {
      select.open(); // Open the dropdown if it's closed
    }
  }


  // Check if a step is completed
  isStepCompleted(index: number): boolean {
  
    return this.completedSteps.has(index);
  }

  // Enable "Run" button only if the previous step has been completed
  isStepRunnable(index: number): boolean {
    return index === 0 || this.completedSteps.has(index - 1);
  }

  goback() {
    // this.promptDetails.reset();
    // this.title.reset();
    this.router.navigateByUrl('/home/dashboard');
  }



  show_Tooltip() {
    clearTimeout(this.hideTimeout); // Prevent hiding if quickly re-hovered
    this.showTooltip1 = true;
  }

  hide_Tooltip() {
    this.hideTimeout = setTimeout(() => {
      this.showTooltip1 = false;
    }, 1000); // Hide tooltip after 5 seconds
  }

  getChangeMode = ""
  checkChanges(mode: string) {
    let getShowUnsavedData = localStorage.getItem("showUnsavedDataChanges")
    this.getChangeMode = mode;
    if(getShowUnsavedData == 'true') {
      this.showUnsavedDataChanges.set(true);
    }
    
    if(this.enableRating() == true && this.promptUserDetails.average_rating == 0) {
      const ratingDialogRef = this.dialog.open(RatingFeedbackComponent, {
        data: {
          message: this.promptUserDetails.title,
          prompt_id_val: this.prompt_id,
          rating: this.promptUserDetails.my_rating,
          prompt_details:this.promptUserDetails,
          remind_me_later_count:this.promptUserDetails?.remind_me_later_count
        },
        width: '500px',
        height: '610px'
      });

      ratingDialogRef.afterClosed().subscribe((rating_res) => {
       
        this.enableRating.set(false);
        this.promptUserDetails.my_rating = rating_res?.rating > 0 ? rating_res?.rating : this.promptUserDetails.my_rating;
        this.promptUserDetails.remind_me_later_count=rating_res?.remind_me_later_count>0 ? rating_res?.remind_me_later_count :this.promptUserDetails.remind_me_later_count;
        this.promptUserDetails.comments=rating_res?.comments ? rating_res?.comments :this.promptUserDetails.comments;
        //this.promptUserDetails.prompt_details.time_saved=rating_res?.time_saved>0 ? rating_res?.time_saved :this.promptUserDetails?.prompt_details?.time_saved;

       
        if(!rating_res.showMsg) {
          if(this.promptModified() == true && !this.showUnsavedDataChanges()) {
            const modifiedChangesDialogRef = this.dialog.open(ModifiedChangesComponent, {
              data: {
                mode: mode
              },
              height: '280px',
              width: '450px',
            });
            modifiedChangesDialogRef.afterClosed().subscribe((result) => {
              if(result.goBack && result.mode == 'non-edit') {
                this.goback();
              }
              if(result.goBack && result.mode == 'user') {
                this.goback();
              }
              if(result.goBack  && result.mode == 'edit') {
                this.isEditMode = false;
                this.promptModified.set(false);
                this.resetClick(false, result.event);
                this.getPromptDetails();
              }
              this.showUnsavedDataChanges.set(result.showAgain) 
              localStorage.setItem("showUnsavedDataChanges", result.showAgain)
              this.getChangeMode = result.mode
            });   
          }
        }
      });    
    } else if(this.promptModified() == true && !this.showUnsavedDataChanges()) {
      const dialogRef = this.dialog.open(ModifiedChangesComponent, {
        // data: {
        //   actionType: actionType,
        //   title: title,
        //   promId: promId ? promId : this.promptUserService.prompt_id
        // },
        data: {
          mode: mode
        },
        height: '280px',
        width: '450px'
      });
  
      dialogRef.afterClosed().subscribe((result) => {
        // if(result.goBack) {
        //   this.goback();
        // }
        if(result.goBack && result.mode == 'non-edit') {
          this.goback();
        }
        if(result.goBack && result.mode == 'user') {
          this.goback();
        }
        if(result.goBack  && result.mode == 'edit') {
          this.isEditMode = false;
          this.promptModified.set(false);
          this.resetClick(false, result.event);
          this.getPromptDetails();
        }
        this.showUnsavedDataChanges.set(result.showAgain) 
        localStorage.setItem("showUnsavedDataChanges", result.showAgain)
        this.getChangeMode = result.mode
      });    
    } else if(this.getChangeMode == 'edit' && this.showUnsavedDataChanges()) {
      this.isEditMode = false;
      // this.resetClick(false, result.event);
      // this.getPromptDetails();
    } else {
      this.goback();
    }
  }

  onPromptUpdate(event: any) {
    this.promptModified.set(true);
  }

  // Handle the "Run" button click
  onStepRun(index: number): void {
    this.completedSteps.add(index);
    //this.steps.toArray()[index].completed = true; 
  }

  // onFileChange(event: any) {
  //   const file: File = event.target?.files[0];

  //   if (file) {
  //     this.files.push(file);
  //     // this.attachments.push(file.name);
  //     this.attachments.push({
  //       "selected": {
  //         "name": file.name
  //       },
  //       "index": this.attachments.length,
  //     });
  //   }
  // }

  // onFileChange(event: any) {
  //   const file: File = event.target?.files[0];

  //   if (file) {
  //     this.files.push(file);
  //     this.attachments.push(file.name);
  //   }
  //   this.otherAttachmentsNextContainer?.nativeElement.scrollIntoView({
  //     behavior: 'smooth',
  //     block: 'end'
  //   });
  // }
  onEdit() {
    this.isEditMode = true;
   
  }

  getAllCate(search_text: '', userid: number, modal: [], category_id: [], sub_category_id: [], createdbyarray: [], onMyFavouriteClick: boolean, onMyPromptsClick: boolean, user_role: string, status: []) {
    this.promptCreateService.getAllCate("", userid, modal, category_id, sub_category_id, createdbyarray, onMyFavouriteClick, onMyPromptsClick, user_role, status).subscribe(res => {
      res?.data?.forEach((r: any) => {
        this.updatedCategories.push({ id: r.id, name: r.name, value: r })
      })
      this.category_id = this.updatedCategories[0].id
      this.subcategories = this.updatedCategories[0]?.value?.subcategories ? this.updatedCategories[0].value.subcategories : [];

    })
  }

   extractValues(str: string): (string | string[])[] {
    const regex = /\[\[(.*?)\]\]/g;
    const matches = [];
    let match;
  
    while ((match = regex.exec(str)) !== null) {
      const content = match[1];
      if (content.includes('/')) {
        matches.push(content.split('/'));
      } else {
        matches.push(content);
      }
    }
  
    return matches;
  }

  onUpdate() {
    
    // this.getPromptDetails()
    
    let attachment=this.attachmentTabs.map((data:any)=> ({
      permanentAttachments:[],
      otherAttachment:[]
    }));
    //this.attachment[index]?.attachmentForm?.controls?.permanentAttachments
   
    const additionalAttachments = this.attachmentTabs.map((tab:any)=> tab.attachmentForm?.controls['permanentAttachments'].value?.map(
      (val: any) => val?.selected?.name
    ) || []);

    
    const otherAttachments = this.attachmentTabs.map((tab:any)=> tab.attachmentForm?.controls['otherAttachment'].value?.map(
      (val: any) => val?.selected?.name
    ) || []);
    
    attachment?.forEach((data:any,index:number)=>{
      data?.permanentAttachments?.push(...this.promptUserDetails?.prompt_details[index]?.permanent_attachments,...additionalAttachments[index]);
      data?.otherAttachment?.push(...this.promptUserDetails?.prompt_details[index]?.attachments,...otherAttachments[index]);;
        });

    
    //let attachment=this.attachmentTabs;
    
    
    if (this.promptUserDetails) {
      const dialogRef = this.dialog.open(OnUpdateComponent, {
        data: {
          title: this.promptUserDetails.title,
          category: this.promptUserDetails.category,
          promptUserDetails: this.promptUserDetails,
          subcategories: this.promptUserDetails.sub_category,
          attachmentTab:attachment,//attachmentTab
          estimated_time: this.estimated_time,
          promptData: {
            promptDetails: this.promptUserDetails?.prompt_details[0].prompt,
            description: this.promptUserDetails.description,
            categories: this.updatedCategories,
            perminentAttachments: [...this.promptUserDetails?.prompt_details[0].permanent_attachments, ...[1]], //additionalAttachments
            prompt_id:
              (this.prompt_id !== undefined || this.prompt_id !== null) ? this.prompt_id : null,
            category_id: this.promptUserDetails.category?.category_id,
            prompt_detail_id:
              this.promptUserDetails !== undefined
                ? this.promptUserDetails?.prompt_details[0].prompt_detail_id
                : null,
            notes: this.promptUserDetails?.notes,
            prompt_variable:(this.promptUserDetails?.prompt_details.map((data:any) => this.extractValues(data.prompt))),
            attachments:this.attachmentTabs[0]?.attachmentForm?.controls['otherAttachment'].value?.map((val:any) => val?.selected?.name) ||[],
            action_type: 'submit',
          },
          // message:res.message,
          // action_type: 'add'
        },
      });
      dialogRef.afterClosed().subscribe((res: any) => {
        this.savedData = res;
        this.isEditMode = false;
        this.estimated_time = res?.prompt?.estimated_time;
        this.getPromptDetails()
      });
    } else {
      const dialogRef = this.dialog.open(OnUpdateComponent, {
        data: {
          // title: this.promptDetails.value,
          // promptData: this.chainpromptdata,
          message: "Updated Successfully",
          action_type: 'Update'
        },
      });
      dialogRef.afterClosed().subscribe((res: any) => {
        this.savedData = res;
        this.getPromptDetails();
      })
    }
  }

  parseData(data:any){
    
    if(this.promptUserDetails?.prompt_details.length ==1 ){
    this.promptUserDetails.prompt_details[0].prompt=data;
    }
  }

  onCancel(event: Event) {
    if(this.promptModified() == true) {
      this.checkChanges("edit")
    } else {
      this.isEditMode = false;
    }
  }

  callFunction(){
   if (!this.promptUserDetails?.is_user_executed) {
      this.checkChanges('user');
    } 
    // else if (this.promptUserDetails?.my_rating && this.promptUserDetails?.my_rating > 0 && this.promptUserDetails?.is_user_executed) {
    //   this.checkChanges('user');
    // } 
    else {
      this.checkChanges('user');
      if(this.isExecuted && !this.feedbackStatus){
      this.addToFeedback(this.promptUserDetails?.prompt_id);
      }
    }
  }

  addToFeedback(prompt_id?:any,prompt_title?:any) {
    this.feedbackStatus=true;

    localStorage.removeItem('prompt_status');
    // if (this.user_role === 'user') {

      const dialogRef = this.dialog.open(RatingFeedbackComponent, {
        data: {
          message:prompt_title??'',
          prompt_id_val:prompt_id ??'',
          rating: this.promptUserDetails?.my_rating,
          prompt_details:this.promptUserDetails,
          laterClickCount: this.laterClickCount, // Pass count to dialog
          remind_me_later_count:this.promptUserDetails?.remind_me_later_count
        },
        width: '500px',
        height: '610px',
        disableClose: true // Prevent closing without interaction
      });
      // dialogRef.afterClosed().subscribe(data => {
      //   this.router.navigateByUrl('/home/dashboard');
      // })
      dialogRef.afterClosed().subscribe(data => {
        
        this.promptUserDetails.my_rating = data?.rating > 0 ? data?.rating : this.promptUserDetails.my_rating;
        this.promptUserDetails.remind_me_later_count=data?.remind_me_later_count>0 ? data?.remind_me_later_count :this.promptUserDetails.remind_me_later_count;
        this.promptUserDetails.comments=data?.comments ? data?.comments :this.promptUserDetails.comments;
        //this.promptUserDetails.prompt_details.time_saved=data?.time_saved>0 ? data?.time_saved :this.promptUserDetails?.prompt_details?.time_saved;

        

        //this.promptUserDetails.average_rating = data?.rating > 0 ? data?.rating : this.promptUserDetails.average_rating;
        if (data?.clickedLater) {
          this.laterClickCount++; // Increment if "Later" was clicked
        }
      })
    // }
    //  else {
    //   this.router.navigateByUrl('/home/dashboard');
    // }
  }

  onRunClick() {
    this.disableNext = false;
  }
  onNextClick() {
    this.isNextClick = true;
    this.stepper?.next();
    this.isSidebarOpen = false;
  }

  onPreviousClick() {
    this.isPrevioustClick = true;
    this.stepper?.previous();
    this.isSidebarOpen = false;
  }
  isFirstStep(): boolean {
    if(this.stepper) {
      return this.stepper?.selectedIndex === 0;
    } else {
      return true;
    }
  }

  isLastStep(): boolean {
    return this.stepper?.selectedIndex === this.stepper?.steps?.length - 1;
  }

  isLastTab(): void {
    setTimeout(() => {
      this.zone.run(() => {
        this.isLast = this.tabGroup?.selectedIndex === this.tabGroup?._tabs?.length - 1;
      });
    }, 0);
  }

  isFirstTab(): void {
    setTimeout(() => {
      this.zone.run(() => {
        this.isFirst = this.tabGroup?.selectedIndex === 0;
      });
    }, 0);
  }

  nextTab(): void {
    const totalTabs = this.tabGroup._tabs.length;
    if (this.selectedtab < totalTabs - 1) {
      this.selectedtab++;
    }
    this.isFirstTab();
    this.isLastTab();
  }

  previousTab(): void {
    if (this.selectedtab > 0) {
      this.selectedtab--;
    }
    this.isFirstTab();
    this.isLastTab();
  }

  getPromptDetails() {

    this.style2 = true;
    this.prompt_id = this.prompt_id ? this.prompt_id : localStorage.getItem("promptId");
    const user_id = this.userid
    let length= 0;
    let executedStep:number[]=[];
    this.promptUserService.getPromptUser(this.prompt_id, user_id).subscribe((resp) => {      
      
      this.promptUserDetails = resp.data;
      length= this.promptUserDetails?.prompt_details?.length;
      this.estimated_time = this.promptUserDetails?.estimated_time || 0.00;
      
      this.promptUserDetails?.prompt_details?.forEach((data:any,index:number)=>{
        this.msg.push([]);
        
        if(data.is_user_executed){
          executedStep.push(index);
        
        }
        if (index === length - 1) {
         
          if(executedStep?.length == length){
            executedStep=[];
          }
          this.completedSteps=new Set([ ...executedStep]);
        }
      })
       
       
      const { model_id, model_name } = this.promptUserDetails?.prompt_details?.[0]?.llm || {};
      // this.selectedModelId = { id: model_id, name: model_name, value: model_name };
      
      this.selectedModelId=this.models().find(model=>model.id === model_id)?? null;
      
      
       setTimeout(() => {
        let getIndex: any = localStorage.getItem("promptSelectedIndex");
        if (getIndex) {
          if (this.stepper) {
            this.selectedIndex = +getIndex;
            this.stepper.selectedIndex = this.selectedIndex;
          }
          localStorage.removeItem("promptSelectedIndex");
        }
      }, 50);
      if (this.promptUserDetails && this.promptUserDetails?.category) {
        this.categories = Object.values(this.promptUserDetails?.category);
        this.createdBy = Object.values(this.promptUserDetails?.created_by);
        this.promptCreatedBy = this.promptUserDetails?.created_by.user_name;
        this.promptCategory = this.promptUserDetails?.category.category_name;
        this.promptSubcategory = this.promptUserDetails?.sub_category?.sub_category_name;
        this.isfavourite = this.promptUserDetails?.is_favourite
        this.promptId = this.promptUserDetails?.id
        //  this.promptSubcategory=this.promptUserDetails?.sub_category.category_name;
        this.handleSelectedPromptDetails();

        this.tabs = [];
        this.promptUserDetails?.prompt_details.map((data: any, index: number) => {
          if (data.status === 'REVOKED' || data.status === 'REJECTED') {
            this.isRevokedRejected = true
          }
          this.myForm = this.fb.group({
            promptDetails: data?.prompt,
            variables: this.fb.array((data?.variables || []).map((variable: string) => this.fb.control(variable))),
            variablesCopy: this.fb.array([]),
            gptQuestion: ""
          });
          this.tabs.push({ label: `Prompt ${index}`, myForm: this.myForm });
          this.parsePromptText(index)

          if(this.promptUserService.RhsPanelStatus() == false) {
            this.attachmentForm = this.fb.group({
              otherAttachment: [null],
              permanentAttachments :[null],
            });
            if(this.attachmentTabs.length < this.promptUserDetails?.prompt_details.length){
            this.attachmentTabs.push({ attachmentForm: this.attachmentForm });
            }
          }
        })
       
        if (this.promptUserDetails.notes === '') {
          this.showNotes = false;
        } else {
          this.noteslist = this.convertToList(this.promptUserDetails.notes);
        }
        this.parsePromptText(this.promptUserService.stepperPosition());
      }
      if (localStorage.getItem("uploadDocsResponseSet")) {
        setTimeout(() => {
          this.scrollToBottomMainScroll();
        }, 10);
        localStorage.removeItem("uploadDocsResponseSet");
        // let serviceAttchements = this.promptCreateService.getStoredAttachments();
        // if (serviceAttchements.length > 0) {
        //   serviceAttchements.forEach((item: any) => {
        //     this.files.push(item);
        //     // this.attachments.push(file.name);
        //     this.attachments.push({
        //       "selected": {
        //         "name": item.name
        //       },
        //       "index": this.attachments.length,
        //     });
        //   });

        //   this.onInsertPrompt();
        // }

        if(this.attachmentTabs[this.promptUserService.stepperPosition()].attachmentForm.value.otherAttachment) {
          //this.onInsertPrompt();
        }else{
          if ((this.attachments && this.attachments.length > 0)) {
            //this.onInsertPrompt();
          }
        }
      } else {
        // if ((this.attachments && this.attachments.length > 0)) {
        //   setTimeout(() => {
        //     this.scrollToBottomMainScroll();
        //   }, 10);
        //   this.onInsertPrompt();
        // }
        if(this.attachmentTabs[this.promptUserService.stepperPosition()].attachmentForm.value.otherAttachment) {
          //this.onInsertPrompt();
        }
      }
    })
  }

  version_reason:any='';
  created_from:any=''
  tooltipStyle: { [key: string]: string } = {};
  showVariantInstruction:boolean=false;
  variant_reason:any='';
  variant_created_from:any=''
  
  showVersionTooltip(event: MouseEvent,tooltip: string,prompt:any) {
    if(tooltip == 'version'){
      this.showVersionInstruction = true;
      this.version_reason=prompt?.version_reason;
      this.created_from=prompt?.source_version == 0?'Initial Prompt':`version ${prompt?.source_version}`;
      const target = event.target as HTMLElement;
      const rect = target.getBoundingClientRect();

      const tooltipWidth = 150; // Adjust based on actual tooltip width or estimate
      
      const padding = 10;

      let left = rect.right;
      let transform = 'translateX(0%)';

  //  If tooltip would overflow the screen to the right, shift to left side
  if (rect.right + tooltipWidth + padding > window.innerWidth) {
    left = rect.left-tooltipWidth+40 ;

    transform = 'translateX(0%)'; // Or leave as is
  }

  this.tooltipStyle = {
    top: rect.bottom-10 + 'px',
    left: left + 'px',
    transform,
    position: 'absolute',
  };

    }
    else  if(tooltip == 'variant'){
      this.showVariantInstruction = true;
      this.variant_reason=prompt?.variant_reason;
      this.variant_created_from=prompt?.variant_source == 0?'Initial Prompt':`${prompt?.variant_source}`;
 
      const target = event.target as HTMLElement;
      const rect = target.getBoundingClientRect();

      const tooltipWidth = 150; // Adjust based on actual tooltip width or estimate
      
      const padding = 10;

      let left = rect.right;
      let transform = 'translateX(0%)';

  //  If tooltip would overflow the screen to the right, shift to left side
  if (rect.right + tooltipWidth + padding > window.innerWidth) {
    left = rect.left-tooltipWidth+40 ;
   
    transform = 'translateX(0%)'; // Or leave as is
  }

  this.tooltipStyle = {
    top: rect.bottom-10 + 'px',
    left: left + 'px',
    transform,
    position: 'absolute',
  };
    
    }
  }
  hideVersionTooltio(tooltip: string) {
    if(tooltip == 'version'){
      this.showVersionInstruction = false;
     

    }else  if(tooltip == 'variant'){
      this.showVariantInstruction = false;

    }
    
  }


  handleSelectedPromptDetails() {
    let detail: any = this.promptUserDetails?.prompt_details[this.selectedIndex];
    this.gptScore = !detail?.llm?.model_status ? `${detail.llm.model_name} (Deactivated)`: detail.llm.model_name;
    this.permanentAttachments = detail.permanent_attachments ?? [];
    this.showDefaultType = this.promptUserDetails?.prompt_type !== 'chain';
    this.promptDetailsId = detail.prompt_detail_id;
    // if (detail?.attachments) {
    //   detail?.attachments.map((attachment: any, index: number) => {
    //     this.attachments.push({
    //       "selected": { "name": attachment },
    //       "index": index
    //     });
    //   }) ?? [];
    // }
    this.fetchChats(this.promptUserDetails?.prompt_id, detail.prompt_detail_id);
  }

  onApproveClick() {
    const dialogRef = this.dialog.open(ApprovePromptComponent, {
      data: this.promptUserDetails,
      height:'370px',
      width: '450px'
    });
  }

  onRejectClick() {
    const dialogRef = this.dialog.open(RejectPromptComponent, {
      data: this.promptUserDetails,
      height: '80vh',
      width: '450px'
    });
  }

  removeFavouite(actionType: any, title: string, promId: number = 0) {
    const dialogRef = this.dialog.open(RemoveFavoriteComponent, {
      data: {
        actionType: actionType,
        title: title,
        promId: promId ? promId : this.promptUserService.prompt_id
      },
      height: '250px',
      width: '450px'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.remove_fav) {
        this.addToFavouite(result.action_type, title, result.prompt_id);
        this.isfavourite = false;
      }
    });    
  }

  addToFavouite(actionType: any, prompt_name: string, promId: number) {
    // const promt_id = 
    // const user_id = this.user_id
    //const promt_id = this.promptUserService.prompt_id
    let request = {
      // "prompt_id": this.prompt_id,
      "prompt_id": promId,
      "user_id": this.userid,
      "action_type": actionType
    }

    this.promptUserService.addToFavouite(request).subscribe(res => {
      const dialogRef = this.dialog.open(FavComponentDailogComponent, {
        data: {
          message: res.message,
          action_type: actionType,
          favpromtname: prompt_name
        },

      });

    });

    setTimeout(() => {
      this.getPromptDetails();
    }, 400);
  }

  resetClick(isEditmode: boolean, event: Event) {
    // this.formdata.reset();
    // this.promptUserDetails = this.promptUserDetails;

    if(isEditmode) {
      this.promptUserDetails.notes="";
      this.promptUserDetails.prompt_details[0].prompt="";
      this.promptUserDetails.title="";
      
      let tabForm = this.tabs[this.promptUserService.stepperPosition()].myForm
      tabForm.reset({
        promptDetails: this.promptUserDetails.prompt_details[this.promptUserService.stepperPosition()].prompt,
        gptQuestion: ""
      })
      let v_form = tabForm.get('variables') as FormArray
      let vc_form = tabForm.get('variablesCopy') as FormArray
      v_form.clear();
      vc_form.clear();

      this.attachmentTabs[this.promptUserService.stepperPosition()].attachmentForm.reset({
        otherAttachment: [],
        permanentAttachments :[],
      })  
    } else {
      let tabForm = this.tabs[this.promptUserService.stepperPosition()].myForm
      tabForm.reset({
        promptDetails: this.promptUserDetails.prompt_details[this.promptUserService.stepperPosition()].prompt,
        gptQuestion: ""
      })
      let v_form = tabForm.get('variables') as FormArray
      let vc_form = tabForm.get('variablesCopy') as FormArray
      v_form.clear();
      vc_form.clear();

      this.attachmentTabs[this.promptUserService.stepperPosition()].attachmentForm.reset({
        otherAttachment: [],
        permanentAttachments :[],
      })
    }
    this.parsePromptText(this.promptUserService.stepperPosition());
    if(isEditmode) {
      this.getPromptDetails();
    }
  }

  promptVariableResetHandler(event: Event) {
    const variablesArray = this.tabs[this.promptUserService.stepperPosition()].myForm.get('variables') as FormArray;
    variablesArray.clear();

    const variablesCopyArray = this.tabs[this.promptUserService.stepperPosition()].myForm.get('variablesCopy') as FormArray;
    variablesCopyArray.clear();
    this.parsePromptText(this.promptUserService.stepperPosition());
  }

  formdata = this.fb.group({
    topic: ['', []], Adjective: ['', []], Adjective1: ['', []], topic1: ['', []], Adjective2: ['', []]
  });

  resetedClick() {

  }

  // deleteFile(index: number, type: string) {
  //   this.attachments = this.attachments.filter((_, i) => i !== index) 
  // }

  // deleteFile(fileType: string, index: number) {
  //   if (fileType === 'perminentAttachments') {
  //     // handeling remain prompt details
  //   } else {
  //     this.files.splice(index, 1);
  //     this.attachments = this.attachments.filter((_, i) => i !== index);
  //   }
  // }

  // onInputChange(i: any, event: any) {
  //   const pageNumber = event.target.value.trim();
  //   this.attachments[i].page_number = pageNumber;
  
  // }

  onInputChange(tab_index: number, attachment_index: number, event: any) {
    let otherAttachments = this.attachmentTabs[tab_index].attachmentForm.value.otherAttachment;
    const pageNumber = event.target.value.trim();

    // Update the page_number for the specified attachment_index
    if (Array.isArray(otherAttachments) && otherAttachments[attachment_index]) {
      // Update the page_number for the specified attachment index
      otherAttachments[attachment_index].page_number = pageNumber;

      // If needed, reassign the updated array back to the form
      this.attachmentTabs[tab_index].attachmentForm.patchValue({
        otherAttachment: otherAttachments
      });
    } else {
      console.warn(`Attachment at index ${attachment_index} does not exist.`);
    }
    // this.attachments[i].page_number = pageNumber;

  }

  // deleteOtherFile(type: string) {
  //   // this.attachments = this.attachments.filter((_, i) => i !== index) 
  //   this.otherAttachments = '';
  // }

  getFormattedFileNames(fileNames: any) {
    return fileNames.join(" ,");
  }

  changePromptDetails(event: any) {
    this.isSidebarOpen = false;
    if (!this.isPromptGenerating) {
      if (this.selectedIndex != event?.selectedIndex || this.selectedIndex != event?.index) {
        this.selectedIndex = event?.selectedIndex == 0 || event?.selectedIndex ? event?.selectedIndex : event?.index;
        this.promptUserService.setStepperIndex(event?.selectedIndex == 0 || event?.selectedIndex ? event?.selectedIndex : event?.index);
        this.selectedtab = event?.selectedIndex == 0 || event?.selectedIndex ? event?.selectedIndex : event?.index;
        this.enableChatPrompt = false;
        this.messages = [];
        this.pdfText = '';
        this.promptText = '';
        this.chatId = undefined;
        this.currChatId.set({chat_id: "", message_id: ""});
        this.projectCode = '';
        this.files = [];
        this.handleSelectedPromptDetails();
        this.renderBotMsg(this.messages);
        this.isTextareaExpanded = false
      }
    }
   
    if(this.selectedIndex == 0 || this.selectedIndex ){
      const { model_id, model_name } = this.promptUserDetails?.prompt_details?.[this.selectedIndex]?.llm || {};
      this.selectedModelId=this.models().find(model=>model.id === model_id)?? null;
    }
    this.parsePromptText(this.selectedIndex);
  }

  async onInsertPrompt(val?:any) {
    this.template_converted=true;
    // this.onStepRun(val);
    this.isLoading = true;
    const selectedVariablescopy = this.tabs[this.promptUserService.stepperPosition()].myForm.get('variablesCopy') as FormArray;
    const selectedVariables = this.tabs[this.promptUserService.stepperPosition()].myForm.get('variables') as FormArray;

    // Check if any variable is empty
    const hasEmptyVariable = selectedVariablescopy.value.some((item: any) => {
      if(item?.historyFlowStates === "inprogress") {
        return true 
      } else if(item === "") {
        return true
      }
      return false;
    });

    if (hasEmptyVariable) {
      this.openSnackbar("Please complete the variable selection to insert and execute the prompt", 'Incomplete variable selection', 'error-snackbar');
      this.isLoading = false;
      return;
    }

    this.isPromptInserting = true;
    let promptDetails: any;
    promptDetails = JSON.parse(JSON.stringify(this.promptUserDetails.prompt_details[this.selectedIndex]));

    let otherAttachmentsList = this.attachmentTabs[this.promptUserService.stepperPosition()].attachmentForm.value.otherAttachment || [];
    
    let selectedFiles = [];
    let uploaded_files_items = [];
    let passedFileItems = [];
    let merged_uploaded_files_items: any = [];

    // if(otherAttachmentsList) {
      selectedFiles = otherAttachmentsList.map((item: any) => {
        return item.selected
      })

      uploaded_files_items = otherAttachmentsList.map((item: any) => {
        return {
          file_name: item?.selected?.name || '',
          selected_pages: item.page_number && item.page_number.trim() ? item.page_number.split(',').map((page: string) => Number(page.trim())) : []
        }
      })
      

      let vPdfDocData = selectedVariablescopy.value.map((vItem: any) => {
          if (Object.keys(vItem?.pdfDocData || {}).length > 0) {
            return {
              file_name: vItem?.pdfDocData?.file_name,
              selected_pages: vItem?.pdfDocData?.selected_pages,
              label_name: vItem?.pdfDocData?.label_name.replace('\n', '').trim('')
            };
          }
          return null; // Explicitly return null or undefined
        }).filter((item: any) => item !== null); // Remove null values
      

      // merged_uploaded_files_items = uploaded_files_items.map((uploaded_file: any) => {
      //   let match = vPdfDocData.find((vPdf: any) => vPdf.file_name === uploaded_file.file_name);
      //   return match ? match : uploaded_file
      // })
      

      merged_uploaded_files_items = [...vPdfDocData]
     
      uploaded_files_items.forEach((uploadedItem: any) => {
        if (!merged_uploaded_files_items.some((pdfItem: any) => pdfItem.file_name === uploadedItem.file_name)) {
          merged_uploaded_files_items.push(uploadedItem);
        }
      });
      

      passedFileItems = otherAttachmentsList.map((item: any, item_index: number) => {
        return {
          selected: {
            name: item?.selected?.name || '',
          },
          page_number: item.page_number,
          index: item_index
        }
      })
    // }

    let promptDetailStoredData = this.promptUserDetails?.prompt_details[this.selectedIndex];

    const uploadPromises = otherAttachmentsList.map(async (newFile: any) => {
      if(!promptDetailStoredData.attachments.includes(newFile.selected.name)) {
        const presSignedUrlRequest = {
          prompt_id: this.promptUserDetails?.prompt_id,
          title: this.promptUserDetails?.prompt_details[this.selectedIndex]?.prompt_name,
          url_type: 'put_object',
          prompt_detail_id: promptDetailStoredData?.prompt_detail_id,
          attachment_type: "attachments",
          file_name: newFile.selected.name,
          user_id:this.userid
        }
        try {
          const response = await this.promptCreateService.getPresignedUrl(presSignedUrlRequest).toPromise();
          if (response?.data) {
            const presignedUrl = response.data.url;
            await this.promptCreateService.uploadFileToS3(presignedUrl, newFile.selected!).toPromise();
            console.log(`Uploaded: ${newFile.selected.name}`);
          }
        } catch (err) {
          console.error(`Error uploading ${newFile.selected.name}:`, err);
        }
      }
    });
    
    await Promise.all(uploadPromises); 
    

    let runPromptRequest: any;
    runPromptRequest = {
      // question: promptDetails.prompt,
      question: this.tabs[this.promptUserService.stepperPosition()].myForm.value.gptQuestion,
      user_id: this.userid,
      prompt_title: this.promptUserDetails?.title,
      prompt_id: this.promptUserDetails?.prompt_id,
      is_draft_prompt: false,
      permanentAttachments: this.perminentAttachments.map((file: any) => { return file.selected }),
      // attachments: this.files,
      attachments: selectedFiles,
      // uploaded_files: this.attachments.map((file: any) => {
      //   return {
      //     file_name: file.selected?.name || '',
      //     selected_pages: file.page_number && file.page_number.trim() ? file.page_number.split(',').map((page: string) => Number(page.trim())) : []
      //   };
      // })
      uploaded_files: merged_uploaded_files_items
      // uploaded_files: uploaded_files_items
    };
    this.promptCreateService.onRunPrompt(runPromptRequest)
    .pipe(
      catchError((error) => {
        console.error('Error occurred:', error);
        
        this.isLoading = false;
        
        // Ensure UI doesn't freeze
        this.isPromptInserting = false;
        if(error.status == 400) {
          this.openSnackbar('Please enter valid page number within the PDF page range', 'An error occurred', 'error-snackbar');
        }

        // Return an empty observable to prevent breaking the subscription
        return of(null);
      }),
      finalize(() => {
        // Always reset the loading state, whether success or error
        this.isPromptInserting = false;
        this.isLoading = false;
      })
    ).subscribe((res) => {
      if (res && res["status_code"] === 200) {
        this.isPromptInserting = false;
        this.enableChatPrompt = true;
        // this.promptText = this.promptQuestion = res.data.question;
        let escapeNonHtmlTags = this.promptQuestion = this.escapeNonHtmlTags(res.data.question);
        this.promptText = escapeNonHtmlTags.replace(/\[\^\d+\^\]/g, '');

        let extractedPdfContent = res.data.pdf_text;
        if(extractedPdfContent?.length > 0) {
          let vcTransformedData = selectedVariablescopy.value.map((vItem: any) => {
            if (Object.keys(vItem?.pdfDocData || {}).length > 0) {
              let match = extractedPdfContent.find((ePdf: any) => ePdf.filename === vItem?.pdfDocData?.file_name);
              if(match) {
                return {
                  ...vItem,
                  "pdfDocData": {
                    ...vItem.pdfDocData,
                    page_content: match.page_content
                  },
                  "varGptData": match.page_content
                }
              }
            }
            return vItem; // Explicitly return null or undefined
          }).filter((item: any) => item !== null); // Remove null values
         

          let vTransformedData = selectedVariables.value.map((vItem: any) => {
            if (Object.keys(vItem?.pdfDocData || {}).length > 0) {
              let match = extractedPdfContent.find((ePdf: any) => ePdf.filename === vItem?.pdfDocData?.file_name);
              if(match) {
                return {
                  ...vItem,
                  "pdfDocData": {
                    ...vItem.pdfDocData,
                    page_content: match.page_content
                  },
                  "varGptData": match.page_content
                }
              }
            }
            return vItem; // Explicitly return null or undefined
          }).filter((item: any) => item !== null); // Remove null values

          
          

          selectedVariables.patchValue(vTransformedData);
          selectedVariablescopy.patchValue(vcTransformedData);

       
          this.updateInputPromptText(this.promptUserService.stepperPosition());
          // this.promptText = this.tabs[this.promptUserService.stepperPosition()].myForm.value.gptQuestion;
          let escapeNonHtmlTags = this.escapeNonHtmlTags(this.tabs[this.promptUserService.stepperPosition()].myForm.value.gptQuestion);
          this.promptText = escapeNonHtmlTags.replace(/\[\^\d+\^\]/g, '');
          
        }

        // if (res.data && res.data.pdf_text) {
        //   this.pdfText = res.data.pdf_text;
        //   let tempStr = "";
        //   this.pdfText.forEach((pdftext: any) => {
        //     tempStr += pdftext + "\n"
        //   });
        //   if (this.pdfText.length == 0) {
        //     this.pdfText = '';
        //   }
        //   if (tempStr) {
        //     this.promptText = tempStr + "\n" + this.promptQuestion;
        //   } else {
        //     this.promptText = this.promptQuestion;
        //   }
        // }

        this.projectCode = res.data.project_code ? res.data.project_code : undefined;
        if (this.projectCode.includes("temp")) {
          localStorage.setItem("hasProjectCode", this.projectCode);
        }
        this.fileNames = JSON.parse(JSON.stringify(res.data.file_names));
        // this.passedFileNames = JSON.parse(JSON.stringify(this.attachments));
        this.passedFileNames = JSON.parse(JSON.stringify(passedFileItems));
        this.promptResponse = res.data;
        this.chatId = undefined;
        this.currChatId.set({chat_id: "", message_id: ""});
        this.adjustHeight(this.promptUserService.stepperPosition());
      } else if (res && res["status_code"] === 202) {
        
        
          let pagesWithStr: any = {};
          let questionData: any;
          questionData = res?.data?.question;
          runPromptRequest.uploaded_files.forEach((item:any) => {
            pagesWithStr[item.file_name] = item.selected_pages.join('_');
          })
          
          let postData = {
            project_code: res?.data?.project_code,
            user_id: this.userid,
            filenames: res?.data?.file_names,
            pages_as_string: pagesWithStr
          }
  
          
          this.pollingDialogRef = this.dailog.open(PollingDialogComponent, {
            height: '250px',
            width: '450px',
            disableClose: true
          });
  
          this.pollingRunPromptInterval = setInterval(() => {
            this.promptCreateService.pollingApi(postData).pipe(
              catchError((error) => {
                console.error('Error occurred:', error);
                this.isLoading = false;
                this.isPromptRunning = false;
                this.openSnackbar('Please enter valid page number within the PDF page range', 'An error occurred', 'error-snackbar');
                return of(null);
              }),
              finalize(() => {
                this.isPromptRunning = false;
                this.isLoading = false;
              })
          ).subscribe((resp:any) => {
            if (resp && resp.data && resp.data.length) {
              this.promptCreateService.updateData(true);
              // this.clearPolling();
              clearInterval(this.pollingRunPromptInterval);
              // this.pollingDialogRef.close();
              this.isPromptRunning = false;
              this.enableChatPrompt = true;
             
              
              const quetionText = this.escapeNonHtmlTags(questionData);
              // this.promptText = `${quetionText}</br> <span class="var-text doc">${resp.data[0].page_content}</span>`;
              // this.promptText = `${quetionText}</br> <span class="var-text doc">${resp.data.map((item: any) => item.page_content).join(' ')}</span>`;
  
              // let extractedPdfContent = res.data.pdf_text;
              let extractedPdfContent = resp.data;
              
              
              if(extractedPdfContent?.length > 0) {
              
                // let pageContent = `${resp.data.map((item: any) => item.page_content).join(' ')}`;
                
                let vcTransformedData = selectedVariablescopy.value.map((vItem: any) => {
                  if (Object.keys(vItem?.pdfDocData || {}).length > 0) {
                    let match = extractedPdfContent.find((ePdf: any) => ePdf.filename === vItem?.pdfDocData?.file_name);
                    if(match) {
                      return {
                        ...vItem,
                        "pdfDocData": {
                          ...vItem.pdfDocData,
                          page_content: match.page_content
                        },
                        "varGptData": match.page_content
                      }
                    }
                  }
                  return vItem;
                }).filter((item: any) => item !== null);
                
  
                let vTransformedData = selectedVariables.value.map((vItem: any) => {
                  if (Object.keys(vItem?.pdfDocData || {}).length > 0) {
                    let match = extractedPdfContent.find((ePdf: any) => ePdf.filename === vItem?.pdfDocData?.file_name);
                    if(match) {
                      return {
                        ...vItem,
                        "pdfDocData": {
                          ...vItem.pdfDocData,
                          page_content: match.page_content
                        },
                        "varGptData": match.page_content
                      }
                    }
                  }
                  return vItem;
                }).filter((item: any) => item !== null);
                selectedVariables.patchValue(vTransformedData);
                selectedVariablescopy.patchValue(vcTransformedData);
                this.updateInputPromptText(this.promptUserService.stepperPosition());
                let escapeNonHtmlTags = this.escapeNonHtmlTags(this.tabs[this.promptUserService.stepperPosition()].myForm.value.gptQuestion);
                this.promptText = escapeNonHtmlTags.replace(/\[\^\d+\^\]/g, '');
              }
              this.projectCode = res?.data?.project_code ? res?.data?.project_code : undefined;
              if (this.projectCode?.includes("temp")) {
                localStorage.setItem("hasProjectCode", this.projectCode);
              }
              this.fileNames = JSON.parse(JSON.stringify(resp.data.map((item: any) => item.filename)));
              
              
              this.passedFileNames = JSON.parse(JSON.stringify(passedFileItems));
              this.promptResponse = res.data;
              this.chatId = undefined;
              this.currChatId.set({ chat_id: "", message_id: "" });
              this.adjustHeight(this.promptUserService.stepperPosition());
              this.isLoading = false;
            }
          }, (error) => {
            clearInterval(this.pollingRunPromptInterval);
          }
        )
        }, 5000);
        }
    })
  }

  escapeNonHtmlTags(text: string): string {
    const validTags = ['b', 'i', 'u', 'strong', 'em', 'p', 'br', 'span', 'div', 'ul', 'li', 'ol', 'a', 'img', 'table', 'tr', 'td', 'th', 'thead', 'tbody', 'tfoot'];

    return text.replace(/<\/?([a-zA-Z0-9-]+)[^>]*>/g, (match, tag) => {
      // If the tag is in the valid list, return it unchanged
      if (validTags.includes(tag.toLowerCase())) {
        return match;
      }
      // Otherwise, escape it
      return match.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    });
  }

  showGptEditIcon = signal<boolean>(false)
  adjustHeight(index: number): void {
    this.template_converted=false;
    let mainContainer = document.getElementById("rightSideChatCOntext") as HTMLElement;
    let maxHeight = Math.round(mainContainer.offsetHeight / 2);

    setTimeout(() => {
      const textarea = document.getElementById("singleChatPromptTextArea_0") as HTMLTextAreaElement || document.getElementById("multiChatPromptTextArea_" + index) as HTMLTextAreaElement || document.getElementById("editChatPromptTextArea_" + index) as HTMLTextAreaElement;
      // textarea.style.height = 'auto'; // Reset height to allow shrinking
      if (textarea.scrollHeight > 28) {
        this.isMultiText = true;
      } else {
        this.isMultiText = false;
      }

      if (textarea.scrollHeight > 37) {
        this.shrinkFooter = true;
      } else {
        this.shrinkFooter = false;
      }

      if (textarea.scrollHeight > maxHeight) {
        textarea.style.height = `${maxHeight}px`;
        textarea.style.overflow = `auto`;
      } else {
        textarea.style.height = 'auto';
        textarea.style.height = `${textarea.scrollHeight}px`
        textarea.style.overflow = `hidden`;
      }

      if(textarea.scrollHeight > 100) {
        this.showGptEditIcon.set(true)
      } else {
        this.showGptEditIcon.set(false)
      }

      // textarea.scrollTop = textarea.scrollHeight;
    }, 200)
  }

  trackPromptExecuted: boolean = false;
  trackPromptExecutedSteps = new Set<number>();
  sendChatPrompt(type?: string, val?:any) {
    if(this.selectedModelId == null){
      // confirm("Select some Model.....");
      this.openSnackbar('Model selection is required for prompt execution.', 'Model selection', 'error-snackbar');
      this.model_issue=true;
      return;
    }
    const selectedVariablescopy = this.tabs[this.promptUserService.stepperPosition()].myForm.get('variablesCopy') as FormArray;
    const selectedVariables = this.tabs[this.promptUserService.stepperPosition()].myForm.get('variables') as FormArray;
    this.onStepRun(val);
    let index= val ? val:0;
    if(type == 'chain' && (this.promptUserDetails.total_views == null || this.promptUserDetails.total_views == 0)) {
      this.trackPromptExecutedSteps.add(val)
      if(this.promptUserDetails.prompt_details.length == this.trackPromptExecutedSteps.size) {
        this.trackPromptExecuted = true
      }
    } else if(this.promptUserDetails.total_views == null || this.promptUserDetails.total_views == 0) {
      this.trackPromptExecuted = true
    }

    // if (this.user_role === 'user' && this.enableRating() == false) {
    //   this.enableRating.set(true);
    // }
    
    let promptDetails: any;
    promptDetails = JSON.parse(JSON.stringify(this.promptUserDetails.prompt_details[this.selectedIndex]));

    let otherAttachmentsList = this.attachmentTabs[this.promptUserService.stepperPosition()].attachmentForm.value.otherAttachment;
    let uploaded_files_list = []
    if(otherAttachmentsList) {
      uploaded_files_list = otherAttachmentsList.map((item: any) => {
        return {
          file_name: item?.selected?.name || '',
          selected_pages: []
        }
      })
    }

    let vPdfDocData = selectedVariablescopy.value.map((vItem: any) => {
      if (Object.keys(vItem?.pdfDocData || {}).length > 0) {
        return {
          file_name: vItem?.pdfDocData?.file_name,
          selected_pages: vItem?.pdfDocData?.selected_pages,
          label_name: vItem?.pdfDocData?.label_name.replace('\n', '').trim(''),
          page_content: vItem?.pdfDocData?.page_content
        };
      }
      return null; // Explicitly return null or undefined
    }).filter((item: any) => item !== null); // Remove null values
    

    let merged_uploaded_files_items = uploaded_files_list.map((uploaded_file: any) => {
          let match = vPdfDocData.find((vPdf: any) => vPdf.file_name === uploaded_file.file_name);
          return match ? match : uploaded_file
        })
      

    // let merged_uploaded_files_items = [...vPdfDocData]
    
    // uploaded_files_list.forEach((uploadedItem: any) => {
    //   if (!merged_uploaded_files_items.some((pdfItem: any) => pdfItem.file_name === uploadedItem.file_name)) {
    //     merged_uploaded_files_items.push(uploadedItem);
    //   }
    // });


    let var_uploaded_files: any = []
    selectedVariablescopy.value.forEach((vItem: any) => {
      if(vItem?.chatHistoryDocs?.length > 0) {
        vItem?.chatHistoryDocs.forEach((item: any) => {
          var_uploaded_files.push(item);
        })
      }
    })

    let vChatVarData = selectedVariablescopy.value.map((vChatItem: any) => {
      if (Object.keys(vChatItem?.chatVar || {}).length > 0) {
        return {
          ...vChatItem.chatVar,
          prompt_id: vChatItem.promptId,
          prompt_detail_version_id: vChatItem.promptVersionId
        };
      }
      return null; // Explicitly return null or undefined
    }).filter((item: any) => item !== null); // Remove null values
  

    let vUserData = selectedVariablescopy.value.map((userInput: any, i: number) => {
      if (this.isString(userInput)) {
        let userInputKey = selectedVariables.value[i];
        return {
          userInputKey: userInputKey,
          userInputValue: userInput
        };
      }
      return null; // Explicitly return null or undefined
    }).filter((item: any) => item !== null); // Remove null values

    let variables = {
      document: vPdfDocData,
      chat_history: vChatVarData,
      uploaded_attachments: [],
      user_input_variable: vUserData
      // uploaded_attachments is part of chat var will uncomment if required.
      // uploaded_attachments: var_uploaded_files
    }

    // const marked_prompt_text = marked(this.promptText);
    let marked_prompt_text;
    if(this.template_converted){
     marked_prompt_text = marked(this.promptText);
     this.template_converted=false;
    
    }else{
      marked_prompt_text = marked(this.escapeNonHtmlTags(this.promptText));
     
    } 
  
    const safe_prompt_text = marked_prompt_text instanceof Promise
        ? marked_prompt_text
            .then((htmlString: string) =>
              this.htmlToPlainText(htmlString)
            )
            .catch((error) => {
              console.error(
                "Error processing async markdown:",
                error
              );
              return null;
            })
        : this.htmlToPlainText(marked_prompt_text);

    let requestData = {
      // "question": this.promptText,
      "question": safe_prompt_text,
      "user_id": this.userid,
      "prompt_id": this.promptUserDetails?.prompt_id ?? null,
      "prompt_detail_version_id": promptDetails.prompt_detail_id,
      "version_number": promptDetails.version_number,
      // "llm_model": "gpt-4o",
      // "llm_model_id": promptDetails.llm?.model_id || 2,
      "llm_model": this?.selectedModelId?.value,
      "llm_model_id": this?.selectedModelId?.id,
      "pdf_text": this.pdfText || "",
      "embedding_model": "text-embedding-3-large",
      // "chat_id": this.chatId ? this.chatId : undefined,
      "chat_id": this.currChatId().chat_id ? this.currChatId().chat_id : undefined,
      "is_prompt_saved_or_submitted": false,
      "project_code": this.projectCode,
      "uploaded_files": merged_uploaded_files_items,
      "prompt_variables": variables
      // "uploaded_files": uploaded_files_list,
      // "uploaded_files": this.attachments.map((file) => {
      //   return {
      //     file_name: file.selected?.name || '',
      //     selected_pages: []
      //   };
      // })
    }

    this.passedFileNames.forEach((file: any) => {
      this.messages.push({
        type: "file",
        value: file.selected?.name,
        isPrompt: true,
        question: ''
      });
    });
    this.messages.push({
      type: "text",
      value: this.template_converted?this.promptText:marked_prompt_text,
      isPrompt: true,
      question: ''
    });
    this.messages.push({
      type: "text",
      value: this.generatingLoadText,
      isPrompt: false,
      question: safe_prompt_text
      // question: this.promptText
    });
    this.fileNames = [];
    this.passedFileNames = [];
    this.promptText = "";
    this.isMultiText = false;
    this.shrinkFooter = false;
    this.pdfText = "";

    this.enableChatPrompt = false;
    this.isPromptGenerating = true;
    this.msg[index]=this.messages;
    this.renderBotMsg(this.msg[index]);
    setTimeout(() => {
      this.scrollToBottom();
    }, 50);

    this.promptCreateService.executePromptApi(requestData).then(async (response) => {
      const {data, message, status_code} = await response;
      if(status_code == 200) {
        this.currChatId.set({chat_id: data.chat_id, message_id: data.message_id})

        //Reset polling limit
        this.getPromptAnswerLimit = 0;
        
        // Start polling executePrompt every 5 seconds
        this.startExecutePromptPolling();
        
      }

      // const reader = response.body?.getReader();
      // const decoder = new TextDecoder('utf-8');

      // if (!reader) {
      //   this.typingInProgress = false;
      //   this.enableChatPrompt = true;
      //   this.isPromptGenerating = false;
      //   this.messages[this.messages.length - 1].value = "Something went wrong while generating the answer";
      //   this.fetchChats(this.promptUserDetails?.prompt_id, promptDetails.prompt_detail_id);
      //   return;
      // }

      // let done = false;
      // // let chunk = '';
      // let partialChunk = ''; // To store incomplete JSON chunks


      // while (!done) {
      //   const { value, done: streamDone } = await reader.read();
      //   done = streamDone;

      //   if (value) {

      //     const chunk = decoder.decode(value, {stream: true});
      //     partialChunk += chunk; // Accumulate chunk data

      //     // Split the accumulated chunk into potential JSON objects
      //     const jsonStrings = partialChunk.split('}{');

      //     // Clear partialChunk to reaccumulate incomplete JSON chunks
      //     partialChunk = '';

      //     const jsonArray = []; // Temporary array for complete JSON objects
      //     for (let i = 0; i < jsonStrings.length; i++) {
      //       let jsonString = jsonStrings[i];

      //       // Add missing braces to form valid JSON
      //       if (i > 0) jsonString = `{${jsonString}`;
      //       if (i < jsonStrings.length - 1) jsonString += `}`;

      //       try {
      //         const parsedObject = JSON.parse(jsonString);
      //         jsonArray.push(parsedObject); // Collect valid JSON objects
      //       } catch (e) {
      //         // If JSON parsing fails, save as a partial chunk
      //         partialChunk = jsonString;
      //       }
      //     }

      //     // Process the collected JSON objects
      //     jsonArray.forEach((item: any) => {
      //       if (!isFirstTime) {
      //         this.messages[this.messages.length - 1].value = ""; // Clear initial message
      //         isFirstTime = true;
      //       }

      //       this.chatId = item.chat_id;
      //       this.messages[this.messages.length - 1].value += item.answer; // Append answer
      //       this.scrollToBottom();
      //     });



      //     // Fix boundaries to make valid JSON objects
      //     // for (let i = 0; i < jsonStrings.length; i++) {
      //     //   let jsonString = jsonStrings[i];

      //     //   // Add missing braces to form valid JSON
      //     //   if (i > 0) jsonString = `{${jsonString}`;
      //     //   if (i < jsonStrings.length - 1) jsonString += `}`;

      //     //   try {
      //     //     const parsedObject = JSON.parse(jsonString);

      //     //     if (!isFirstTime) {
      //     //       this.messages[this.messages.length - 1].value = "";
      //     //       isFirstTime = true;
      //     //     }

      //     //     this.chatId = parsedObject.chat_id;
      //     //     this.messages[this.messages.length - 1].value += parsedObject.answer;
      //     //     this.scrollToBottom();
      //     //   } catch (e) {
      //     //     // If JSON parsing fails, it's an incomplete chunk; keep accumulating
      //     //     if (i === jsonStrings.length - 1) {
      //     //       partialChunk = jsonString; // Save for the next iteration
      //     //     } else {
      //     //       console.error('Failed to parse chunk:', e, jsonString);
      //     //     }
      //     //   }
      //     // }

      //     // chunk = decoder.decode(value, { stream: true });
      //     // let lines = chunk.split('\n');
      //     // chunk = lines.pop() || '';
      //     // if (!isFirstTime) {
      //     //   this.messages[this.messages.length - 1].value = "";
      //     //   isFirstTime = true;
      //     // }
      //     // if(chunk.length > 0) {
      //     //   const jsonArray = chunk.split('}{').map((str, index) => {
      //     //     // Fix the string to be a valid JSON object by adding braces
      //     //     if (index > 0) str = `{${str}`;
      //     //     if (index < chunk.split('}{').length - 1) str = `${str}}`;
      //     //     return JSON.parse(str);
      //     //   });
      //     //   jsonArray.forEach((item: any) => {
      //     //     this.chatId = item.chat_id;
      //     //     this.messages[this.messages.length - 1].value += item.answer;
      //     //     this.scrollToBottom();
      //     //   });
      //     // }
      //   }
      //   if (done) {
      //     this.typingInProgress = false;
      //     this.enableChatPrompt = true;
      //     this.isPromptGenerating = false;
      //     this.fetchChats(this.promptUserDetails?.prompt_id, promptDetails.prompt_detail_id);
      //   }
      // }
    }, (err) => {
      this.typingInProgress = false;
      this.enableChatPrompt = true;
      this.isPromptGenerating = false;
      this.messages[this.messages.length - 1].value = "Something went wrong while generating the answer";
      this.msg[index].messages[this.messages.length - 1].value = "Something went wrong while generating the answer";
      this.fetchChats(this.promptUserDetails?.prompt_id, promptDetails.prompt_detail_id);
      this.renderBotMsg(this.messages);
    });

    if(!this.logged_version_ids.includes(promptDetails.prompt_detail_id) && promptDetails.status == "PUBLISHED") {
      let executedRequestData = {
        "prompt_id": this.promptUserDetails?.prompt_id ?? null,
        "prompt_detail_version_id": promptDetails.prompt_detail_id,
        "model_id": this?.selectedModelId?.id,
        "executed_by": this.userid,
        "total_words": 100,
        "tokens": 1,
        "cost_per_run": 1,
        "error": "",
        "response": ""
      }

      let length=this.promptUserDetails?.prompt_details?.length;
        if(this.promptUserDetails && this.promptUserDetails?.prompt_details[length-1].prompt_detail_id === promptDetails?.prompt_detail_id){
          if(!this.promptUserDetails?.is_user_executed){
            this.promptUserDetails.is_user_executed=true;
          }
          this.isExecuted=true;
          
        }
        this.promptCreateService.executePrompt(executedRequestData).subscribe({
          next(value) {
        
          },
          error(err) {
            console.log("Log Api", err)
          },
          complete() {},
        })
    
   
      this.logged_version_ids.push(promptDetails.prompt_detail_id)
    }
    
  }

  getPromptAnswer() {
    const chataData = this.currChatId()
    let requestData = {
      // "prompt_id": this.promptUserDetails?.prompt_id,
      "chat_id": chataData.chat_id,
      "message_id": chataData.message_id
    }
    this.promptCreateService.getPromptAnswerApi(requestData).then(async (res) => {
      try {
        // let api_res = await res.json();
        // if( Object.keys(api_res.data).length !== 0 && api_res.data.constructor === Object) {
          if( Object.keys(res.data).length !== 0 && res.data.constructor === Object) {
          let promptDetails = JSON.parse(JSON.stringify(this.promptUserDetails.prompt_details[this.selectedIndex]));
          this.clearPolling(); // Stop polling

          let isFirstTime = false;
          if (!isFirstTime) {
            this.messages[this.messages.length - 1].value = "";
            isFirstTime = true;
          }

          this.currChatId.set({chat_id: res.data.chat_id, message_id: chataData.message_id})
          this.chatId = res.data.chat_id;
          this.messages[this.messages.length - 1].value += res.data.answer; // Append answer
          this.messages[this.messages.length - 1].citations = res.data.citations; // Append answer
          
          this.typingInProgress = false;
          this.enableChatPrompt = true;
          this.isPromptGenerating = false;
          this.fetchChats(this.promptUserDetails?.prompt_id, promptDetails.prompt_detail_id);
          this.renderBotMsg(this.messages);
          setTimeout(() => {
            this.scrollToBottom();
          }, 50);
        }
       
      } catch (error) {
        console.log("try_catch_api_error", error)
      }
    }).catch(err => {
      console.log("getPromptAnswerApi_PromiseError", err)
      this.clearPolling(); // Stop polling
      this.messages[this.messages.length - 1].value = "Something went wrong while generating the answer";
      this.typingInProgress = false;
      this.enableChatPrompt = true;
      this.isPromptGenerating = false;
      this.renderBotMsg(this.messages);
    })
  }

  startExecutePromptPolling() {
    console.log('Polling started...');
    this.pollingInterval = setInterval(() => {
      if(this.getPromptAnswerLimit < this.timeOutCounterLimit) {
        this.getPromptAnswer();
      } else {
        this.clearPolling(); // Stop polling
        this.messages[this.messages.length - 1].value = "Timeout error";
        this.typingInProgress = false;
        this.enableChatPrompt = true;
        this.isPromptGenerating = false;
        this.renderBotMsg(this.messages);
      }
      this.getPromptAnswerLimit += 1
      
    }, 5000); // Poll every 5 seconds
  }

  clearPolling() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      console.log('Polling stopped');
    }
  }

  // sendChatPrompt Working code...#

  // sendChatPrompt() {

  //   let promptDetails: any;
  //   promptDetails = JSON.parse(JSON.stringify(this.promptUserDetails.prompt_details[this.selectedIndex]));

  //   let otherAttachmentsList = this.attachmentTabs[this.promptUserService.stepperPosition()].attachmentForm.value.otherAttachment;
  //   let uploaded_files_list = []
  //   if(otherAttachmentsList) {
  //     uploaded_files_list = otherAttachmentsList.map((item: any) => {
  //       return {
  //         file_name: item?.selected?.name || '',
  //         selected_pages: []
  //       }
  //     })
  //   }

  //   let requestData = {
  //     "question": this.promptText,
  //     "user_id": this.userid,
  //     "prompt_id": this.promptUserDetails?.prompt_id ?? null,
  //     "prompt_detail_version_id": promptDetails.prompt_detail_id,
  //     "version_number": promptDetails.version_number,
  //     "llm_model": "gpt-4o",
  //     "llm_model_id": promptDetails.llm?.model_id || 2,
  //     "pdf_text": this.pdfText || "",
  //     "embedding_model": "text-embedding-3-large",
  //     "chat_id": this.chatId ? this.chatId : undefined,
  //     "is_prompt_saved_or_submitted": false,
  //     "project_code": this.projectCode,
  //     "uploaded_files": uploaded_files_list,
  //     // "uploaded_files": this.attachments.map((file) => {
  //     //   return {
  //     //     file_name: file.selected?.name || '',
  //     //     selected_pages: []
  //     //   };
  //     // })
  //   }
  //   this.passedFileNames.forEach((file: any) => {
  //     this.messages.push({
  //       type: "file",
  //       value: file.selected?.name,
  //       isPrompt: true,
  //       question: ''
  //     });
  //   });
  //   this.messages.push({
  //     type: "text",
  //     value: this.promptText,
  //     isPrompt: true,
  //     question: ''
  //   });
  //   this.messages.push({
  //     type: "text",
  //     value: this.generatingLoadText,
  //     isPrompt: false,
  //     question: this.promptText
  //   });
  //   this.fileNames = [];
  //   this.passedFileNames = [];
  //   this.promptText = "";
  //   this.isMultiText = false;
  //   this.shrinkFooter = false;
  //   this.pdfText = "";

  //   this.enableChatPrompt = false;
  //   setTimeout(() => {
  //     this.scrollToBottom();
  //   }, 10);
  //   let isFirstTime = false;
  //   this.enableChatPrompt = false;
  //   this.isPromptGenerating = true;
  //   this.promptCreateService.fetchJsonStream(requestData).then(async (response) => {
  //     const reader = response.body?.getReader();
  //     const decoder = new TextDecoder('utf-8');

  //     if (!reader) {
  //       this.typingInProgress = false;
  //       this.enableChatPrompt = true;
  //       this.isPromptGenerating = false;
  //       this.messages[this.messages.length - 1].value = "Something went wrong while generating the answer";
  //       this.fetchChats(this.promptUserDetails?.prompt_id, promptDetails.prompt_detail_id);
  //       return;
  //     }

  //     let done = false;
  //     // let chunk = '';
  //     let partialChunk = ''; // To store incomplete JSON chunks


  //     while (!done) {
  //       const { value, done: streamDone } = await reader.read();
  //       done = streamDone;

  //       if (value) {

  //         const chunk = decoder.decode(value, {stream: true});
  //         partialChunk += chunk; // Accumulate chunk data

  //         // Split the accumulated chunk into potential JSON objects
  //         const jsonStrings = partialChunk.split('}{');

  //         // Clear partialChunk to reaccumulate incomplete JSON chunks
  //         partialChunk = '';

  //         const jsonArray = []; // Temporary array for complete JSON objects
  //         for (let i = 0; i < jsonStrings.length; i++) {
  //           let jsonString = jsonStrings[i];

  //           // Add missing braces to form valid JSON
  //           if (i > 0) jsonString = `{${jsonString}`;
  //           if (i < jsonStrings.length - 1) jsonString += `}`;

  //           try {
  //             const parsedObject = JSON.parse(jsonString);
  //             jsonArray.push(parsedObject); // Collect valid JSON objects
  //           } catch (e) {
  //             // If JSON parsing fails, save as a partial chunk
  //             partialChunk = jsonString;
  //           }
  //         }

  //         // Process the collected JSON objects
  //         jsonArray.forEach((item: any) => {
  //           if (!isFirstTime) {
  //             this.messages[this.messages.length - 1].value = ""; // Clear initial message
  //             isFirstTime = true;
  //           }

  //           this.chatId = item.chat_id;
  //           this.messages[this.messages.length - 1].value += item.answer; // Append answer
  //           this.scrollToBottom();
  //         });



  //         // Fix boundaries to make valid JSON objects
  //         // for (let i = 0; i < jsonStrings.length; i++) {
  //         //   let jsonString = jsonStrings[i];

  //         //   // Add missing braces to form valid JSON
  //         //   if (i > 0) jsonString = `{${jsonString}`;
  //         //   if (i < jsonStrings.length - 1) jsonString += `}`;

  //         //   try {
  //         //     const parsedObject = JSON.parse(jsonString);

  //         //     if (!isFirstTime) {
  //         //       this.messages[this.messages.length - 1].value = "";
  //         //       isFirstTime = true;
  //         //     }

  //         //     this.chatId = parsedObject.chat_id;
  //         //     this.messages[this.messages.length - 1].value += parsedObject.answer;
  //         //     this.scrollToBottom();
  //         //   } catch (e) {
  //         //     // If JSON parsing fails, it's an incomplete chunk; keep accumulating
  //         //     if (i === jsonStrings.length - 1) {
  //         //       partialChunk = jsonString; // Save for the next iteration
  //         //     } else {
  //         //       console.error('Failed to parse chunk:', e, jsonString);
  //         //     }
  //         //   }
  //         // }

  //         // chunk = decoder.decode(value, { stream: true });
  //         // let lines = chunk.split('\n');
  //         // chunk = lines.pop() || '';
  //         // if (!isFirstTime) {
  //         //   this.messages[this.messages.length - 1].value = "";
  //         //   isFirstTime = true;
  //         // }
  //         // if(chunk.length > 0) {
  //         //   const jsonArray = chunk.split('}{').map((str, index) => {
  //         //     // Fix the string to be a valid JSON object by adding braces
  //         //     if (index > 0) str = `{${str}`;
  //         //     if (index < chunk.split('}{').length - 1) str = `${str}}`;
  //         //     return JSON.parse(str);
  //         //   });
  //         //   jsonArray.forEach((item: any) => {
  //         //     this.chatId = item.chat_id;
  //         //     this.messages[this.messages.length - 1].value += item.answer;
  //         //     this.scrollToBottom();
  //         //   });
  //         // }
  //       }
  //       if (done) {
  //         this.typingInProgress = false;
  //         this.enableChatPrompt = true;
  //         this.isPromptGenerating = false;
  //         this.fetchChats(this.promptUserDetails?.prompt_id, promptDetails.prompt_detail_id);
  //       }
  //     }
  //   }, (err) => {
  //     this.typingInProgress = false;
  //     this.enableChatPrompt = true;
  //     this.isPromptGenerating = false;
  //     this.messages[this.messages.length - 1].value = "Something went wrong while generating the answer";
  //     this.fetchChats(this.promptUserDetails?.prompt_id, promptDetails.prompt_detail_id);
  //   });
  // }

  typeResponse(response: string) {
    let index = 0;

    this.typingInterval = setInterval(() => {
      if (index < response.length) {
        this.messages[this.messages.length - 1].value += response.charAt(index);
        index++;
        this.renderBotMsg(this.messages);
        this.scrollToBottom();
      } else {
        clearInterval(this.typingInterval); // Stop typing when done
        this.typingInProgress = false;
        this.enableChatPrompt = true;
      }
    }, 20); // Adjust typing speed here
  }

  onDelete() {

  }

  onSaveClick(event: any) {

  }
  // onSubmitClick(event: any) {

  // }

  // downloadFile(file: any): void {
  //   // Assuming the file object contains a URL or path to the file
  //   const fileUrl = file.url || file.path || file.name; // Adjust based on your object structure
  //   const fileName = file.name || 'downloaded_file'; // Default file name

  //   // Create a temporary anchor element
  //   const anchor = document.createElement('a');
  //   anchor.href = fileUrl;
  //   anchor.download = fileName;

  //   // Append to the document to trigger download
  //   document.body.appendChild(anchor);
  //   anchor.click();

  //   // Remove the anchor after triggering download
  //   document.body.removeChild(anchor);
  // }

  parsePromptText(tabPositionIndex: number) {
    const promptDesc = this.tabs[tabPositionIndex].myForm.value.promptDetails
    const matches: [string] = promptDesc.match(/\[\[(.*?)\]\]/g);
    this.promptDataEditedVal = promptDesc

    if (matches) {
      const variablesArray = this.tabs[tabPositionIndex].myForm.get('variables') as FormArray;
      const variablesCopyArray = this.tabs[tabPositionIndex].myForm.get('variablesCopy') as FormArray;

      const newVariables = matches.map((match) => {
        const content = match.slice(2, -2); // Remove [ ]
        return content.includes('/') ? content.split('/') : content;
      });

      // Map existing values from promptVariablesCopy to newVariables
      const updatedVariables = newVariables.map((variable, index) => {
        // const existingVariable = this.promptVariables()[index];
        // const isDropdown = Array.isArray(variable);
        // const existingCopy = this.promptVariablesCopy()[index];
        const existingVariable = variablesArray.at(index)?.value;
        const isDropdown = Array.isArray(variable);
        const existingCopy = variablesCopyArray.at(index)?.value;

        // If the variable exists and matches the type, retain its value
        // if (isDropdown && Array.isArray(existingVariable)) {
        //   // return existingCopy || variable;
        //   return existingCopy != "" ? existingCopy : "";
        //   // return existingCopy != "" ? existingCopy : variable;
        // } else if (!isDropdown && typeof existingVariable === 'string') {
        //   // return existingCopy || variable;
        //   // return existingCopy == variable ? existingCopy : variable;
        //   return existingCopy != "" ? existingCopy : "";
        // } else {
        //   // For new variables or type mismatches, initialize to default
        //   return "";
        //   // return variable;
        // }

        // If the variable exists and matches the type, retain its value
        // if (isDropdown && Array.isArray(existingVariable)) {
        //   // return existingCopy || variable;
        //   return (existingCopy == "" || existingCopy == undefined) ? "" : existingCopy;
        // } else if (!isDropdown && typeof existingVariable === 'string') {
        //   // return existingCopy || variable;
        //   return (existingCopy == "" || existingCopy == undefined) ? "" : existingCopy;
        // } else {
        //   // For new variables or type mismatches, initialize to default
        //   // return variable;
        //   return "";
        // }

        // If the variable exists and matches the type, retain its value
        if (isDropdown && Array.isArray(existingVariable)) {
          // return existingCopy || variable;
          return (existingCopy != "" && existingCopy != null) ? existingCopy : "";
          // return existingCopy != "" ? existingCopy : variable;
        } else if (!isDropdown && typeof existingVariable === 'string') {
          // return existingCopy || variable;
          // return existingCopy == variable ? existingCopy : variable;
          return (existingCopy != "" && existingCopy != null) ? existingCopy : "";
        } else if (!isDropdown && typeof existingVariable === 'object') {
          // return existingCopy || variable;
          // return existingCopy == variable ? existingCopy : variable;
          return (existingCopy != "" && existingCopy != null) ? existingCopy : "";
        } else {
          // For new variables or type mismatches, initialize to default
          return "";
          // return variable;
        }
      });

      // this.promptVariables.set(newVariables); // Update with new variables
      // this.promptVariablesCopy.set(updatedVariables); // Retain updated values



      // Clear the current FormArray
      variablesArray.clear();

      // Populate the FormArray with the new values
      // newVariables.forEach((item) => {
      //   if (Array.isArray(item)) {
      //     // If the item is an array, push a new FormArray
      //     variablesArray.push(this.fb.array(item.map((nested) => this.fb.control(nested))));
      //   } else {
      //     // If the item is a string, push a FormControl
      //     variablesArray.push(this.fb.control(item));
      //   }
      // });
      newVariables.forEach((item, i) => {
        if (Array.isArray(item)) {
          // If the item is an array, push a new FormArray
          variablesArray.push(this.fb.array(item.map((nested) => this.fb.control(nested))));
        } else if(typeof(updatedVariables[i]) == 'object') {
          variablesArray.push(this.fb.control(updatedVariables[i]));
        } else {
          // If the item is a string, push a FormControl
          variablesArray.push(this.fb.control(item));
        }
      });



      // Clear the current FormArray
      variablesCopyArray.clear();

      // Populate the FormArray with the new values
      updatedVariables.forEach((item, i) => {
        if (Array.isArray(item)) {
          // If the item is an array, push a new FormArray
          variablesCopyArray.push(this.fb.array(item.map((nested) => this.fb.control(nested))));
        } else if(updatedVariables[i] == undefined) {
          variablesCopyArray.push(this.fb.control(""));
        } else {
          // If the item is a string, push a FormControl
          variablesCopyArray.push(this.fb.control(item));
        }
      });

      this.promptUserDetails.prompt_details[tabPositionIndex].variables = variablesArray.value;
    } else {
      // No matches; clear the variables
      // this.promptVariables.set([]);
      // this.promptVariablesCopy.set([]);

      const variablesArray = this.tabs[tabPositionIndex].myForm.get('variables') as FormArray;
      variablesArray.clear();

      const variablesCopyArray = this.tabs[tabPositionIndex].myForm.get('variablesCopy') as FormArray;
      variablesCopyArray.clear();
    }
    
    // this.tabs[tabPositionIndex].myForm.value.promptDetails = this.promptDataEditedVal;
    this.tabs[tabPositionIndex].myForm.get('promptDetails')?.setValue(this.promptDataEditedVal);
    this.promptUserDetails.prompt_details[tabPositionIndex].prompt = this.promptDataEditedVal;
    this.updateInputPromptText(tabPositionIndex);
  }

  scrollToBottom() {
    const container = this.chatContainer?.nativeElement;
    container?.scrollTo({
      top: container?.scrollHeight,
      behavior: 'smooth', // Enables smooth scrolling
    });
    // container.scrollTop = container.scrollHeight;
  }

  scrollToBottomMainScroll() {
    const container = this.mainScrollContainer.nativeElement;
    container.scrollTop = container.scrollHeight;
  }


  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  toggleGroup(index: number) {
    this.expandedState[index] = !this.expandedState[index];
  }

  fetchChats(prompt_id: any, prompt_version_id: any) {
    const requestData = {
      user_id: this.userid,
      prompt_id: prompt_id,
      prompt_detail_version_id: prompt_version_id,
    };

    this.promptCreateService.getChats(requestData).subscribe((res) => {
      if (res && res["status_code"] === 200) {
        this.chatHistoryData = res.data;
        // Call getChats with the response data from the API
        this.getChats(res.data);
        this.expandedState[0] = true;
      }
    });
  }

  getChats(data: any[]) {
    const groupedChats: { today: any[], yesterday: any[], otherDates: any[] } = {
      today: [],
      yesterday: [],
      otherDates: []
    };

    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    data.forEach((chat: any) => {
      
        const chatDate = new Date(chat.created_datetime);
        const chatDateString = chatDate.toDateString();  // Get only the date part (ignores time)

        // Check if the message is "Today"
        if (this.isSameDay(today, chatDate)) {
          chat["chat_id"] = chat.id;
          chat["isEdit"] = false;
          groupedChats.today.push(chat);
        }
        // Check if the message is "Yesterday"
        else if (this.isSameDay(yesterday, chatDate)) {
          chat["chat_id"] = chat.id;
          chat["isEdit"] = false;
          groupedChats.yesterday.push(chat);
        }
        // Otherwise, group by specific date
        else {
          const existingDateGroup = groupedChats.otherDates.find(group => group.date === chatDateString);
          if (existingDateGroup) {
            chat["chat_id"] = chat.id;
            chat["isEdit"] = false;
            existingDateGroup.chats.push(chat);
            // existingDateGroup.messages.push(chat);
          } else {
            chat["chat_id"] = chat.id;
            chat["isEdit"] = false;
            groupedChats.otherDates.push({
              date: chatDateString,
              chats: [chat]
              // messages: [chat]
            });
          }
        }
    });

    // Construct the final chat history array
    this.chatHistory = [
      { date: 'Today', chats: groupedChats.today },
      { date: 'Yesterday', chats: groupedChats.yesterday },
      ...groupedChats.otherDates
    ];

    //Set initial chat
    if(data.length > 0) {
      this.loadChats({...data[0], chat_id: data[0].id}, false, this.selectedIndex)
    }
  }

  isSameDay(date1: Date, date2: Date) {
    return date1.getDate() === date2.getDate() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getFullYear() === date2.getFullYear();
  }

  newPrompt(index: undefined | number = undefined) {
    this.messages = [];
    if(index != undefined){
      this.msg[index] = [];
    }
    this.enableChatPrompt = true;
    this.promptText = '';
    this.fileNames = [];
    this.passedFileNames = [];
    this.chatId = undefined;
    this.currChatId.set({chat_id: "", message_id: ""});
    this.renderBotMsg(this.messages);
  }

  copyChatHistoryData: SafeHtml | null = null;
  copyChatHistory(prompt_id: any, prompt_detail_version_id: any) {
    const requestData = {
      user_id: this.userid,
      prompt_id: prompt_id,
      prompt_detail_version_id: prompt_detail_version_id,
    };

    return new Promise((resolve, reject) => {
      this.promptCreateService.getChats(requestData).subscribe({
        next: (res) => {
          if (res && res["status_code"] === 200) {
            if (res?.data?.length > 0) {
              const chatData = res.data.flatMap((chat: any) => {
                let question = chat.name ? chat.name : chat.messages[0].question
                let chatQuest ;
                if(this.template_converted){
                  chatQuest = marked(question)
                 }else{
                  chatQuest = marked(this.escapeNonHtmlTags(question))
                  } 
                // const chatQuest = marked(question);
                const chatAnswer = marked(chat.messages[0].answer);
  
                const safeQuest =
                  chatQuest instanceof Promise
                    ? chatQuest
                        .then((htmlString: string) =>
                          this.htmlToPlainText(htmlString)
                        )
                        .catch((error) => {
                          console.error(
                            "Error processing async markdown:",
                            error
                          );
                          return null;
                        })
                    : this.htmlToPlainText(chatQuest);

                const safeAnswer =
                  chatAnswer instanceof Promise
                    ? chatAnswer
                        .then((htmlString: string) =>
                          this.htmlToPlainText(htmlString)
                        )
                        .catch((error) => {
                          console.error(
                            "Error processing async markdown:",
                            error
                          );
                          return null;
                        })
                    : this.htmlToPlainText(chatAnswer);

                return {
                  id: chat.id,
                  question: safeQuest,
                  // question: chatQuest,
                  menuName: safeQuest,
                  answer: chatAnswer,
                  // answer: safeAnswer,
                  name: 'Chat History Selection',
                  chatData: res.data
                };
              });
              // const chatData = res.data.flatMap((chat: any) => {
              //   return chat.messages.map((message: any) => {
              //     const chatQuest = marked(message.question);
              //     const chatAnswer = marked(message.answer);
  
              //     const safeQuest =
              //       chatQuest instanceof Promise
              //         ? chatQuest
              //             .then((htmlString: string) =>
              //               this.htmlToPlainText(htmlString)
              //             )
              //             .catch((error) => {
              //               console.error(
              //                 "Error processing async markdown:",
              //                 error
              //               );
              //               return null;
              //             })
              //         : this.htmlToPlainText(chatQuest);
  
              //     const safeAnswer =
              //       chatAnswer instanceof Promise
              //         ? chatAnswer
              //             .then((htmlString: string) =>
              //               this.htmlToPlainText(htmlString)
              //             )
              //             .catch((error) => {
              //               console.error(
              //                 "Error processing async markdown:",
              //                 error
              //               );
              //               return null;
              //             })
              //         : this.htmlToPlainText(chatAnswer);
  
              //     return {
              //       id: chat.id,
              //       question: safeQuest,
              //       // question: chatQuest,
              //       menuName: safeQuest,
              //       answer: chatAnswer,
              //       // answer: safeAnswer,
              //       name: 'Chat History Selection'
              //     };
              //   });
              // });
  
              resolve(chatData);
            } else {
              resolve([]); // No data, return an empty array
            }
          } else {
            reject("Invalid response status code");
          }
        },
        error: (err) => {
          reject(err); // Handle HTTP errors
        },
      });
    });
  }

  // Utility function to convert sanitized HTML to plain text
  private htmlToPlainText(htmlContent: string): string {
    const doc = new DOMParser().parseFromString(htmlContent, 'text/html');
    return doc.body.textContent || "";
  }

  // copyToClipboard(copiedContent: string, ind: number) {
  //   navigator.clipboard.writeText(copiedContent).then(() => {
  //     const copiedMessageElement = document.getElementById("copied-message-" + ind);
  //     if (copiedMessageElement) {
  //       copiedMessageElement.innerHTML = "Copied";
  //       setTimeout(() => {
  //         copiedMessageElement.innerHTML = "";
  //       }, 400);
  //     }

  //   }).catch(err => {
  //     console.error('Failed to copy: ', err);
  //   });
  // }

  // copyToClipboard(copiedContent: HTMLElement, ind: number, tab_index: number) {
  //   // const textContent = copiedContent?.textContent?.trim() || '';

  //   // Remove unwanted CSS rules using regex or a filter
  //   // const cleanedText = textContent.replace(/(body|h1|h2|pre|p|ul|li|.container)\s*\{[^}]*\}/g, '').trim();

  //   // Retrieve the HTML content, including tags
  //   const htmlContent = copiedContent?.innerHTML?.trim() || '';

  //   // Remove <style> tags and their content
  //   const cleanedText = htmlContent.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '');

  //   // Optionally, use .textContent to get plain text after cleaning
  //   // const plainText = new DOMParser().parseFromString(cleanedText, 'text/html').body.textContent?.trim() || '';
  //   const parsedHtml = new DOMParser().parseFromString(cleanedText, 'text/html');

  //   // Check if the content includes a table
  //   const tableElement = parsedHtml.querySelector('table');

  //   // If a table exists, copy the HTML table; otherwise, copy plain text
  //   const clipboardContent = tableElement
  //     ? tableElement.outerHTML // Copy the table HTML if a table is found
  //     : parsedHtml.body.textContent?.trim() || ''; // Otherwise, copy plain text

  //   navigator.clipboard.writeText(clipboardContent).then(() => {
  //     const copiedMessageElement = document.getElementById("copied-message-" + `${tab_index}` + '-' + `${ind}`);
  //     if (copiedMessageElement) {
  //       copiedMessageElement.innerHTML = "Copied";
  //       setTimeout(() => {
  //         copiedMessageElement.innerHTML = "";
  //       }, 400);
  //     }

  //   }).catch(err => {
  //     console.error('Failed to copy: ', err);
  //   });
  // }

  // copyToClipboard(copiedContent: HTMLElement, ind: number, tab_index: number) {
  //   // Retrieve the HTML content, including tags
  //   const htmlContent = copiedContent?.innerHTML?.trim() || '';

  //   // Remove <style> tags and their content
  //   const cleanedText = htmlContent.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '');

  //   // Parse the cleaned HTML content
  //   const parsedHtml = new DOMParser().parseFromString(cleanedText, 'text/html');

  //   // Check if the content includes a table
  //   const tableElement = parsedHtml.querySelector('table');

  //   // If a table exists, copy the HTML table; otherwise, copy plain text
  //   const clipboardContent = tableElement
  //       ? tableElement.outerHTML // Copy the table HTML if a table is found
  //       : parsedHtml.body.textContent?.trim() || ''; // Otherwise, copy plain text

  //   if (navigator.clipboard && navigator.clipboard.writeText) {
  //       // Use Clipboard API if available
  //       navigator.clipboard.writeText(clipboardContent).then(() => {
  //           this.showCopyMessage(ind, tab_index);
  //       }).catch(err => {
  //           console.error('Failed to copy with Clipboard API: ', err);
  //       });
  //   } else {
  //       // Fallback to document.execCommand for insecure contexts
  //       const textarea = document.createElement('textarea');
  //       textarea.value = clipboardContent;
  //       textarea.style.position = 'fixed'; // Prevent scrolling to bottom
  //       textarea.style.opacity = '0';
  //       document.body.appendChild(textarea);
  //       textarea.select();

  //       try {
  //           const successful = document.execCommand('copy');
  //           if (successful) {
  //               this.showCopyMessage(ind, tab_index);
  //           } else {
  //               console.error('Fallback: Copy command unsuccessful');
  //           }
  //       } catch (err) {
  //           console.error('Fallback: Failed to copy with execCommand: ', err);
  //       } finally {
  //           document.body.removeChild(textarea);
  //       }
  //   }
  // }

  // showCopyMessage(ind: number, tab_index: number) {
  //   const copiedMessageElement = document.getElementById("copied-message-" + `${tab_index}` + '-' + `${ind}`);
  //   if (copiedMessageElement) {
  //       copiedMessageElement.innerHTML = "Copied";
  //       setTimeout(() => {
  //           copiedMessageElement.innerHTML = "";
  //       }, 400);
  //   }
  // }

  copyToClipboard(copiedContent: HTMLElement, ind: number, tab_index: number) {
    if (!copiedContent) {
      console.error("No content to copy");
      return;
    }

    // Extract HTML content
    let htmlContent = copiedContent.outerHTML;
    htmlContent = htmlContent.replace(/<span class="citation-icon-wrap"[^>]*>[\s\S]*?<\/span>/g, '');

    // Extract plain text content for fallback (tab-separated values for tables)
    const plainTextContent = this.convertToPlainText(copiedContent);

    if (navigator.clipboard && navigator.clipboard.write) {
      // Copy both text/plain and text/html formats
      const clipboardItem = new ClipboardItem({
        "text/html": new Blob([htmlContent], { type: "text/html" }),
        "text/plain": new Blob([plainTextContent], { type: "text/plain" }),
      });

      navigator.clipboard.write([clipboardItem]).then(() => {
        this.showCopyMessage(ind, tab_index); // Show confirmation message
      }).catch((err) => {
        console.error("Failed to copy content: ", err);
      });
    } else {
      // Fallback for older browsers
      const cleanedPlainText = htmlContent.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '');
      const parsedHtml = new DOMParser().parseFromString(cleanedPlainText, 'text/html');
      const clipboardContent = parsedHtml.body.textContent?.trim() || '';

      const textarea = document.createElement("textarea");
      textarea.value = clipboardContent;
      document.body.appendChild(textarea);
      textarea.select();

      try {
        const successful = document.execCommand("copy");
        if (successful) {
          this.showCopyMessage(ind, tab_index); // Show confirmation message
        } else {
          console.error("Fallback: Copy command unsuccessful");
        }
      } catch (err) {
        console.error("Fallback: Failed to copy with execCommand: ", err);
      } finally {
        document.body.removeChild(textarea);
      }
    }
  }

  convertToPlainText(element: HTMLElement): string {
    let plainText = "";

    if (element.tagName.toLowerCase() === "table") {
      // Convert table to tab-separated values
      const rows = element.querySelectorAll("tr");
      rows.forEach((row) => {
        const cells = row.querySelectorAll("td, th");
        const cellTexts = Array.from(cells).map(cell => cell.textContent?.trim() || "");
        plainText += cellTexts.join("\t") + "\n"; // Tab-separated for Excel compatibility
      });
    } else {
      // Recursively extract text for other elements
      element.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          plainText += node.textContent?.trim() || "";
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          plainText += this.convertToPlainText(node as HTMLElement) + "\n";
        }
      });
    }

    return plainText.trim();
  }

  showCopyMessage(ind: number, tab_index: number) {
    const copiedMessageElement = document.getElementById("copied-message-" + `${tab_index}` + '-' + `${ind}`);
    if (copiedMessageElement) {
      copiedMessageElement.innerHTML = "Copied";
      setTimeout(() => {
        copiedMessageElement.innerHTML = "";
      }, 400); // Clear the message after 400ms
    }
  }


  // getSafeHtml(content: string): SafeHtml {
  //   return this.sanitizer.bypassSecurityTrustHtml(content);
  // }

  // renderBotMsg(content: any) {
  //   content.map((msg: any) => {
  //     if(!msg.isPrompt) {
  //       msg.safeValue = this.sanitizer.bypassSecurityTrustHtml(msg.value);
  //       // this.safeMessage.set(this.sanitizer.bypassSecurityTrustHtml(msg.value))
  //       setTimeout(() => {
  //         this.scrollToBottom();
  //       }, 50);
  //     }
  //   })
  // }

  @ViewChild('tooltipRef') tooltipRef!: ElementRef;

  citationTooltipVisible: boolean = false;
  citationTooltipTitle: string = '';
  citationTooltipPresignedTitle: string = '';
  citationTooltipContent: string = '';
  citationTooltipStyle: any = {};
  citationType: string = '';
  citationPromptId: number = 0;
  citationPromptVersionId: number = 0;
  citationPromptNumber: number = 0;
  citationFullChat: boolean = true;

  showPdfViewer: boolean = false;
  citationPresignedUrl: string = '';
  citationDocumentName: string = '';
  citationCoordinates: any = [];

  // showChatViewer: boolean = false;
  showChatViewer: WritableSignal<boolean> = signal(false)
  citationChatData: {} = {};
  citationChatId: string = '';
  citationVariableData: string = '';

  async renderBotMsg(content: any) {
    for (const msg of content) {
      if (!msg.isPrompt) {
        try {
          // Resolve the value if it's a Promise
          const value = await Promise.resolve(msg.value);
          // Parse the Markdown into raw HTML
          let rawHtml: string = value ? await marked(value) : '';

          // Replace placeholders with icons and event handlers
          rawHtml = rawHtml.replace(/\[\^(\d+)\^\]/g, (match, citationKey) => {
            const citation = msg.citations[match]; // citations["[^1^]"], citations["[^2^]"], etc.
            if (!citation) return match; // If no match, return as-is

            let iconHtml = '';
            if (citation.type === "document") {
                let doc_name = citation.document_name;
                let pdf_presigned_title = citation.document_name;
                if(citation.selected_pages?.length > 0) {
                  pdf_presigned_title = citation.selected_pages.join("_") + '_' + citation.document_name
                }
                iconHtml = `<img class="citation-icon" src="/assets/icons/document.svg" alt="PDF" data-type="document" data-id="${citationKey}" data-citation-title="${doc_name}" data-citation-presigned-title="${pdf_presigned_title}" data-citation-value="${citation.highlight_content}" data-citation-coordinates="${JSON.stringify(citation.coordinates).replace(/"/g, '&quot;')}" />`;
            } else if (citation.type === "chat_history") {
                iconHtml = `<img class="citation-icon" src="/assets/icons/chat-doc-icon.svg" alt="Chat" data-type="chat_history" data-id="${citationKey}" data-citation-title="${citation.chat_name}" data-citation-prompt-version-id="${citation.prompt_detail_version_id}" data-citation-prompt-id="${citation.prompt_id}" data-citation-chat-id="${citation.chat_id}" data-citation-value="${citation.highlight_content}" />`;
            } else if (citation.type === "variable_input") {
              iconHtml = `<img class="citation-icon" src="/assets/icons/variable_input_icon.svg" alt="Chat" data-type="variable_input" data-id="${citationKey}" data-citation-title="${citation.variable_name}" data-citation-prompt-version-id="${citation.prompt_detail_version_id}" data-citation-prompt-id="${citation.prompt_id}" data-citation-chat-id="${citation.chat_id}" data-citation-value="${citation.highlight_content}" data-variable-data="${JSON.stringify(citation.variable_value).replace(/"/g, '&quot;')}" />`;
            }

            return `<span class="citation-icon-wrap" data-id="${citationKey}" data-type="${citation.type}">${iconHtml}</span>`;
          });

          // Sanitize the HTML
          msg.safeValue = this.sanitizer.bypassSecurityTrustHtml(rawHtml);

          // Scroll to the bottom after rendering messages
          setTimeout(() => {
            this.scrollToBottom();
            this.addClickEvents();
          }, 50);
        } catch (error) {
          console.error('Error processing message:', error);
          msg.safeValue = 'Error rendering message';
        }
      }
    }
  }

  addClickEvents() {
    const icons = this.eRef.nativeElement.querySelectorAll('.citation-icon');
    icons.forEach((icon: HTMLElement) => {
      this.renderer.listen(icon, 'mouseenter', (event) => {
        event.preventDefault();
        const fileId = icon.getAttribute('data-id') ?? ''; // Default to empty string
        const fileType = icon.getAttribute('data-type') ?? '';
        const citationTitle = icon.getAttribute('data-citation-title') ?? '';
        const citationPresignedTitle = icon.getAttribute('data-citation-presigned-title') ?? '';
        const citationValue = icon.getAttribute('data-citation-value') ?? '';
        const citationPromptId =  icon.getAttribute('data-citation-prompt-id') ?? 0;
        const citationPromptVersionId = icon.getAttribute('data-citation-prompt-version-id') ?? 0;
        const citationChatId = icon.getAttribute('data-citation-chat-id') ?? '';
        const citationVariableData = icon.getAttribute('data-variable-data') ?? '';
        let citationCoordinates;
        const coords = icon.getAttribute('data-citation-coordinates');
        if (coords) {
          citationCoordinates = JSON.parse(coords);
        }

        this.citationTooltipTitle = citationTitle || '';
        this.citationTooltipPresignedTitle = citationPresignedTitle || '';
        this.citationTooltipContent = citationValue || '';
        this.citationTooltipVisible = true;
        this.citationType = fileType;
        this.citationPromptId = Number(citationPromptId);
        this.citationPromptVersionId = Number(citationPromptVersionId);
        this.citationChatId = citationChatId;
        this.citationCoordinates = citationCoordinates;
        this.citationVariableData = citationVariableData;
        this.positionTooltip(event.target as HTMLElement);
      });
    });
  }

  positionTooltip(target: HTMLElement) {
    // const rect = target.getBoundingClientRect();
    // const tooltipHeight = 90;
    // const tooltipWidth = 300;
    // const padding = 10;
  
    // const fitsAbove = rect.top >= tooltipHeight + padding;
    // const fitsBelow = window.innerHeight - rect.bottom >= tooltipHeight + padding;
  
    // const top = fitsAbove
    //   ? rect.top - tooltipHeight - padding
    //   : fitsBelow
    //   ? rect.bottom + padding
    //   : rect.top;
  
    // const left = Math.min(
    //   Math.max(rect.left - tooltipWidth / 2 + rect.width / 2, padding),
    //   window.innerWidth - tooltipWidth - padding
    // );
  
    // this.citationTooltipStyle = {
    //   top: `${top}px`,
    //   left: `${left}px`,
    // };

    const windowInnerHeight = window.innerHeight;
    const rect = target.getBoundingClientRect();

    let varCardPosition = (windowInnerHeight - rect.top) - rect.height - 90;
    let transVarCardTopPosition: number = 0;
    if(varCardPosition < 0) {
      transVarCardTopPosition = rect.top - Math.abs(varCardPosition) - 90;
    } else {
      transVarCardTopPosition = rect.top - rect.height - 90
    }

    let varCardHozPosition = window.innerWidth - rect.left - 300
    if(varCardHozPosition < 0) {
      varCardHozPosition = rect.left - Math.abs(varCardHozPosition) - 60;
    } else {
      varCardHozPosition = rect.left - 150
    }

    this.citationTooltipStyle = {
      top: `${transVarCardTopPosition}px`,
      left: `${varCardHozPosition}px`,
    };
  }

  async handleCitationPanel(type: string, title: string, promptId: number, promptVersionId: number) {
    this.showPdfViewer = false;
    if(type == 'document') {
      this.isLoading = true;
      const presSignedUrlRequest = {
        prompt_id: this.promptUserDetails?.prompt_id,
        title: this.promptUserDetails?.prompt_details[this.selectedIndex]?.prompt_name,
        url_type: 'get_object',
        prompt_detail_id: this.promptUserDetails?.prompt_details[this.selectedIndex]?.prompt_detail_id,
        attachment_type: "other_attachments",
        file_name: title,
        user_id:this.userid
      }

      const response = await this.promptCreateService.getPresignedUrl(presSignedUrlRequest).toPromise();

      if(response.status_code == 200) {
        this.isLoading = false;
        this.showPdfViewer = true;
        this.citationPresignedUrl = response.data.url
        // this.citationDocumentName = title
        this.citationDocumentName = this.citationTooltipTitle
      }

      
    } else if(type == 'chat_history') {
      this.showChatViewer.set(false);

      let  filteredChatsParams = this.chatHistoryData
          .filter((item: any) => item.id == this.SELECTED_CHAT_HISTORY_ID)
          .flatMap((chatHistory: any) =>
            chatHistory.prompt_variables.chat_history
          .filter((chat: any) => chat.chat_id == this.citationChatId)
          .map((chat: any) => ({
            chat_id: chat.chat_id,
            messages_selected: chat.messages_selected,
            prompt_detail_version_id: chat.prompt_detail_version_id,
            prompt_id: chat.prompt_id
          })));

      const getChatsParams = filteredChatsParams.length > 0
      ? filteredChatsParams
      : [{
          chat_id: this.citationChatId,
          messages_selected: [],
          prompt_detail_version_id: this.citationPromptVersionId,
          prompt_id: this.citationPromptId
        }];

     

      this.promptCreateService.getChatsById(getChatsParams[0]).subscribe({
        next: (res) => {
          if(res.data.messages.length > 0) {
            this.showChatViewer.set(true);
            this.citationChatData = res.data.messages
            this.citationTooltipTitle = res.data.name
            this.citationPromptNumber = this.promptUserDetails.prompt_details.findIndex((item: any) => item.prompt_detail_id == res.data.prompt_detail_version_id) + 1
            this.citationFullChat = res.data.is_full_chat_history_input
          }
        },
        error: (err) => {
          this.openSnackbar('Unable to get citation value', 'An error occurred', 'error-snackbar')
        },
      });
    } else if(type == "variable_input") {
      this.showChatViewer.set(false);
      if(this.citationVariableData) {
        setTimeout(() => {
          this.showChatViewer.set(true);
        }, 50)
      }
    }
  }

  onVariableChange(index: number, newValue: any, isDropdown: boolean, tabPositionIndex: number, vLabel: string = '') {
    const variablesArray = this.tabs[tabPositionIndex].myForm.get('variables') as FormArray;
    const variablesCopyArray = this.tabs[tabPositionIndex].myForm.get('variablesCopy') as FormArray;

    this.activeVarIndex = index;
    this.activeVarTabIndex = tabPositionIndex;

    //temp if
    if (variablesCopyArray.at(index)) {
      if (variablesCopyArray && variablesCopyArray.at(index)) {
        if(typeof(variablesCopyArray.at(index).value) != 'object') {
          // Replace the control at the specified index with a new FormControl containing the string value
          // const newControl = this.fb.control(isDropdown ? newValue.value : newValue);
          const newControl = this.fb.control(isDropdown ? newValue.value : newValue.target.value);

          // Use the replace method to avoid type conflicts
          variablesCopyArray.setControl(index, newControl);
        }
        if(variablesCopyArray.at(index).value == null) {
          // Replace the control at the specified index with a new FormControl containing the string value
          // const newControl = this.fb.control(isDropdown ? newValue.value : newValue);
          const newControl = this.fb.control(isDropdown ? newValue.value : newValue.target.value);

          // Use the replace method to avoid type conflicts
          variablesCopyArray.setControl(index, newControl);
        }
      } else {
        console.warn(`Index ${index} is out of bounds for variablesCopyArray`);
      }
    }


    if((typeof(variablesCopyArray.at(index).value) == 'object' && 
        newValue.target.value != '@' &&
        newValue.target.value.length > 0 &&
        variablesCopyArray.at(index).value?.historyFlowStates == 'inprogress')) {

          let curr_var = variablesCopyArray.at(index).value;

          const windowInnerHeight = window.innerHeight;
          const target = newValue.target as HTMLElement;
          const rect = target.getBoundingClientRect();

          let taglength = variablesCopyArray.at(index).value.tags.length;
          let subMenuHeightThrottle = 0;
          if(taglength == 1) {
            subMenuHeightThrottle = 83;
          } else if(taglength == 2) {
            subMenuHeightThrottle = 125;
          } else if(taglength == 3) {
            subMenuHeightThrottle = 170;
          }

          let varCardPosition = (windowInnerHeight - rect.top) - subMenuHeightThrottle;
          let transVarCardTopPosition: number = 0;
          if(varCardPosition < 0) {
            transVarCardTopPosition = rect.top - Math.abs(varCardPosition) - 10;
          } else {
            transVarCardTopPosition = rect.top + 2
          }
          
          const currentVariablesValue = variablesArray.at(index).value;
          const currentVariablesCopyValue = variablesCopyArray.at(index).value;
          const updatedVariablesValue = {
            ...currentVariablesValue,
            showPopup: true,
            inputVal: '@',
            position: {
              top: `${transVarCardTopPosition}px`,
              left: `${curr_var.offset + 140}px`
            }
          }
          const updatedVariablesCopyValue = {
            ...currentVariablesCopyValue,
            showPopup: true,
            inputVal: '@',
            position: {
              top: `${transVarCardTopPosition}px`,
              left: `${curr_var.offset + 140}px`
            }
          }

          variablesArray.at(index).patchValue(updatedVariablesValue);
          variablesCopyArray.at(index).patchValue(updatedVariablesCopyValue);
          this.isVariableScrollable = false;
    }

    if((typeof(variablesCopyArray.at(index).value) == 'object' && variablesCopyArray.at(index).value?.historyFlowStates == 'inprogress' && newValue.type == 'focus')) {

      let curr_var = variablesCopyArray.at(index).value;

      const windowInnerHeight = window.innerHeight;
      const target = newValue.target as HTMLElement;
      const rect = target.getBoundingClientRect();

      let taglength = variablesCopyArray.at(index).value.tags.length;
      let subMenuHeightThrottle = 0;
      if(taglength == 1) {
        subMenuHeightThrottle = 83;
      } else if(taglength == 2) {
        subMenuHeightThrottle = 125;
      } else if(taglength == 3) {
        subMenuHeightThrottle = 170;
      }

      let varCardPosition = (windowInnerHeight - rect.top) - subMenuHeightThrottle;
      let transVarCardTopPosition: number = 0;
      if(varCardPosition < 0) {
        transVarCardTopPosition = rect.top - Math.abs(varCardPosition) - 10;
      } else {
        transVarCardTopPosition = rect.top + 2
      }
      
      const currentVariablesValue = variablesArray.at(index).value;
      const currentVariablesCopyValue = variablesCopyArray.at(index).value;
      const updatedVariablesValue = {
        ...currentVariablesValue,
        showPopup: true,
        inputVal: '@',
        position: {
          top: `${transVarCardTopPosition}px`,
          left: `${curr_var.offset + 140}px`
        }
      }
      const updatedVariablesCopyValue = {
        ...currentVariablesCopyValue,
        showPopup: true,
        inputVal: '@',
        position: {
          top: `${transVarCardTopPosition}px`,
          left: `${curr_var.offset + 140}px`
        }
      }

      variablesArray.at(index).patchValue(updatedVariablesValue);
      variablesCopyArray.at(index).patchValue(updatedVariablesCopyValue);
      this.isVariableScrollable = false;
    }

    if((typeof(variablesCopyArray.at(index).value) == 'object' && 
        newValue.target.value == '@' && 
        variablesCopyArray.at(index).value?.historyFlowStates == 'inprogress')) {
      
      let curr_var = variablesCopyArray.at(index).value;

      const windowInnerHeight = window.innerHeight;
      const target = newValue.target as HTMLElement;
      const rect = target.getBoundingClientRect();

      let taglength = variablesCopyArray.at(index).value.tags.length;
      let subMenuHeightThrottle = 0;
      if(taglength == 1) {
        subMenuHeightThrottle = 83;
      } else if(taglength == 2) {
        subMenuHeightThrottle = 125;
      } else if(taglength == 3) {
        subMenuHeightThrottle = 170;
      }

      let varCardPosition = (windowInnerHeight - rect.top) - subMenuHeightThrottle;
      let transVarCardTopPosition: number = 0;
      if(varCardPosition < 0) {
        transVarCardTopPosition = rect.top - Math.abs(varCardPosition) - 10;
      } else {
        transVarCardTopPosition = rect.top + 2
      }

      variablesCopyArray.setControl(index, this.fb.control({
        inputVal: newValue.target.value,
        historyFlowStates: 'inprogress',
        showPopup: true,
        varGptData: curr_var.varGptData,
        label: curr_var.label,
        tags: [...curr_var.tags],
        offset: curr_var.offset,
        pdfDocData: {...curr_var.pdfDocData},
        chatVar: {...curr_var.chatVar},
        chatHistoryDocs: [...curr_var.chatHistoryDocs],
        historyOptions: [...curr_var.historyOptions],
        promptId: curr_var.promptId,
        promptVersionId: curr_var.promptVersionId,
        position: {
          top: `${transVarCardTopPosition}px`,
          left: `${curr_var.offset + 140}px`
          // left: `${rect.left + 20}px`
        }
      }));
      variablesArray.setControl(index, this.fb.control({
        inputVal: newValue.target.value,
        historyFlowStates: 'inprogress',
        showPopup: true,
        tags: [...curr_var.tags],
        offset: curr_var.offset,
        varGptData: curr_var.varGptData,
        label: curr_var.label,
        pdfDocData: {...curr_var.pdfDocData},
        chatVar: {...curr_var.chatVar},
        chatHistoryDocs: [...curr_var.chatHistoryDocs],
        historyOptions: [...curr_var.historyOptions],
        promptId: curr_var.promptId,
        promptVersionId: curr_var.promptVersionId,
        position: {
          top: `${transVarCardTopPosition}px`,
          left: `${curr_var.offset + 140}px`
          // left: `${rect.left + 20}px`
        }
      }));

      this.isVariableScrollable = false;
    }

    if((variablesCopyArray.at(index).value == "@" && variablesCopyArray.at(index).value.length == 1)) {
      

      
      
      // let vOtherOttachments = this.tabs[tabPositionIndex].myForm.value?.attachment;
      // let vOtherOttachments = this.attachmentTabs[tabPositionIndex].attachmentForm.value?.otherAttachment;
      // let vOtherOttachmentsList = [];
      // if(vOtherOttachments?.length > 0) {
      //   vOtherOttachmentsList = vOtherOttachments.map((doc: any) => ({"menuName": doc.selected.name, "name": "From Input Document", "file_url": URL.createObjectURL(doc.selected)}));
      // }

      // let vOtherOttachments = this.tabs[tabPositionIndex].myForm.value?.attachment;
      let vOtherOttachments: any = [];
      let vOtherOttachmentsList: any = [];
      this.attachmentTabs.forEach((item: any) => {
        if(item.attachmentForm.value?.otherAttachment?.length > 0) {
          item.attachmentForm.value?.otherAttachment.forEach((file: any) => {
            vOtherOttachments.push(file)
          })
        }
      })
      if(vOtherOttachments?.length > 0) {
        vOtherOttachmentsList = vOtherOttachments.map((doc: any) => ({"menuName": doc.selected.name, "name": "From Input Document", "file_url": URL.createObjectURL(doc.selected)}));
      }

      if(tabPositionIndex == 0 && vOtherOttachmentsList.length == 0) {
        return;
      }

      const windowInnerHeight = window.innerHeight;
      const target = newValue.target as HTMLElement;
      const rect = target.getBoundingClientRect();

      let varCardPosition = (windowInnerHeight - rect.top) - 83;
      let transVarCardTopPosition: number = 0;
      if(varCardPosition < 0) {
        transVarCardTopPosition = rect.top - Math.abs(varCardPosition) - 10;
      } else {
        transVarCardTopPosition = rect.top + 2
      }

      
      variablesCopyArray.setControl(index, this.fb.control({
        inputVal: newValue.target.value,
        historyFlowStates: 'inprogress',
        showPopup: true,
        tags: [],
        offset: 0,
        varGptData: "",
        label: vLabel,
        pdfDocData: {},
        chatVar: {},
        chatHistoryDocs: [],
        promptId: null,
        promptVersionId: null,
        historyOptions: [
          {
            enabled: tabPositionIndex == 0 ? false : true,
            grayedout: tabPositionIndex == 0 ? false : true,
            name: 'Chat History'
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Prompts', 
            subItems: []
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Chat History Selection', 
            subItems: []
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Chat Output Selection',
            subItems: []
          },
          {
            enabled: vOtherOttachmentsList.length > 0 ? true : false, 
            grayedout: vOtherOttachmentsList.length > 0 ? true : false, 
            name: 'From Input Document', 
            subItems: [...vOtherOttachmentsList]
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Page Selection',
            subItems: []
          },
        ],
        position: {
          top: `${transVarCardTopPosition}px`,
          left: `${rect.left + 20}px`
        }
      }));
      variablesArray.setControl(index, this.fb.control({
        inputVal: newValue.target.value,
        historyFlowStates: 'inprogress',
        showPopup: true,
        tags: [],
        offset: 0,
        varGptData: "",
        label: vLabel,
        pdfDocData: {},
        chatVar: {},
        chatHistoryDocs: [],
        promptId: null,
        promptVersionId: null,
        historyOptions: [
          {
            enabled: tabPositionIndex == 0 ? false : true,
            grayedout: tabPositionIndex == 0 ? false : true,
            name: 'Chat History'
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Prompts', 
            subItems: []
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Chat History Selection', 
            subItems: []
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Chat Output Selection',
            subItems: []
          },
          {
            enabled: vOtherOttachmentsList.length > 0 ? true : false,
            grayedout: vOtherOttachmentsList.length > 0 ? true : false,
            name: 'From Input Document', 
            subItems: [...vOtherOttachmentsList]
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Page Selection',
            subItems: []
          },
        ],
        // position: transformPosition
        position: {
          top: `${transVarCardTopPosition}px`,
          left: `${rect.left + 20}px`
        }
      }));
      this.isVariableScrollable = false;
    }

    if((typeof(variablesCopyArray.at(index).value) == 'object' &&
        newValue.target.value.length > 0 &&
        variablesCopyArray.at(index).value?.historyFlowStates == 'completed')) {
          const currentVariablesValue = variablesArray.at(index).value;
          const currentVariablesCopyValue = variablesCopyArray.at(index).value;
          const updatedVariablesValue = {
            ...currentVariablesValue,
            inputVal: ''
          }
          const updatedVariablesCopyValue = {
            ...currentVariablesCopyValue,
            inputVal: ''
          }

          variablesArray.at(index).patchValue(updatedVariablesValue);
          variablesCopyArray.at(index).patchValue(updatedVariablesCopyValue);
          this.isVariableScrollable = true;
    }


    this.updateInputPromptText(tabPositionIndex); // Sync inputText with updated variables
    this.promptModified.set(true);
  }

  handleVariableTagSelection(event: any, selectedOption: any, vIndex: number, tabIndex: number) {
    const variablesArray = this.tabs[tabIndex].myForm.get('variables') as FormArray;
    const variablesCopyArray = this.tabs[tabIndex].myForm.get('variablesCopy') as FormArray;

    // Get the current control value
    const currentVariablesValue = variablesArray.at(vIndex).value;
    const currentVariablesCopyValue = variablesCopyArray.at(vIndex).value;

    if(selectedOption.name == "Chat History") {
      let promptData;
      if(this.promptUserDetails) {
        promptData = this.promptUserDetails.prompt_details.filter((_: any, i: number) => i < tabIndex).map((item: any, i: number) => ({
          menuName: 'Prompt ' + (i + 1),
          name: 'Prompts',
          promptId: this.promptUserDetails.prompt_id,
          promptVersionId: item.prompt_detail_id,
        }))
      } else {
        this.isVariableScrollable = true;
        this.openSnackbar("Chat is not available", 'An error occurred', 'error-snackbar')
        return;
      }

      // Update only the specified key
      const updatedVariablesValue = {
        ...currentVariablesValue, // Keep existing values
        tags: [{tag_name: 'Chat History', tag_url: ''}],
        // offset: 120,
        historyOptions: [
          {
            enabled: false,
            grayedout: true,
            name: 'Chat History'
          },
          {
            enabled: true, 
            grayedout: false,
            name: 'Prompts', 
            subItems: promptData
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Chat History Selection', 
            subItems: []
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Chat Output Selection',
            subItems: []
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'From Input Document', 
            subItems: []
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Page Selection',
            subItems: []
          },
        ],
        // position: {
        //   ...currentVariablesValue.position,
        //   left: `${parseInt(currentVariablesValue.position.left.split('px')[0]) + 120}px`
        // }
      };

      // Update only the specified key
      const updatedVariablesCopyValue = {
        ...currentVariablesCopyValue, // Keep existing values
        // tags: ['Chat History'],
        tags: [{tag_name: 'Chat History', tag_url: ''}],
        // offset: 120,
        historyOptions: [
          {
            enabled: false,
            grayedout: true,
            name: 'Chat History'
          },
          {
            enabled: true, 
            grayedout: false,
            name: 'Prompts', 
            subItems: promptData
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Chat History Selection', 
            subItems: []
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Chat Output Selection',
            subItems: []
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'From Input Document', 
            subItems: []
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Page Selection',
            subItems: []
          },
        ],
        // position: {
        //   ...currentVariablesCopyValue.position,
        //   left: `${parseInt(currentVariablesValue.position.left.split('px')[0]) + 120}px`
        // }
      };

      // Update the control with the new value
      variablesArray.at(vIndex).patchValue(updatedVariablesValue);
      variablesCopyArray.at(vIndex).patchValue(updatedVariablesCopyValue);
      this.VariableSubMenu = [];
    } else if(selectedOption.name == 'Prompts') {
      this.copyChatHistory(selectedOption.promptId, selectedOption.promptVersionId).then((chatData) => {
      
        // Update only the specified key
        const updatedVariablesValue = {
          ...currentVariablesValue, // Keep existing values
          tags: [...currentVariablesValue.tags, {tag_name: selectedOption.menuName, tag_url: ''}],
          // tags: [...currentVariablesValue.tags, selectedOption.menuName],
          // offset: 228,
          promptId: selectedOption.promptId,
          promptVersionId: selectedOption.promptVersionId,
          historyOptions: [
            {
              enabled: false,
              grayedout: true,
              name: 'Chat History'
            },
            {
              enabled: false, 
              grayedout: true,
              name: 'Prompts', 
              subItems: [...currentVariablesValue.historyOptions[1].subItems]
            },
            {
              enabled: true, 
              grayedout: false,
              name: 'Chat History Selection', 
              subItems: chatData
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Chat Output Selection',
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'From Input Document', 
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Page Selection',
              subItems: []
            },
          ],
          // position: {
          //   ...currentVariablesValue.position,
          //   left: `${parseInt(currentVariablesValue.position.left.split('px')[0]) + 108}px`
          // }
        };

        // Update only the specified key
        const updatedVariablesCopyValue = {
          ...currentVariablesCopyValue, // Keep existing values
          tags: [...currentVariablesCopyValue.tags, {tag_name: selectedOption.menuName, tag_url: ''}],
          // tags: [...currentVariablesCopyValue.tags, selectedOption.menuName],
          // offset: 228,
          promptId: selectedOption.promptId,
          promptVersionId: selectedOption.promptVersionId,
          historyOptions: [
            {
              enabled: false,
              grayedout: true,
              name: 'Chat History'
            },
            {
              enabled: false, 
              grayedout: true,
              name: 'Prompts', 
              subItems: [...currentVariablesValue.historyOptions[1].subItems]
            },
            {
              enabled: true, 
              grayedout: false,
              name: 'Chat History Selection', 
              subItems: chatData
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Chat Output Selection',
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'From Input Document', 
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Page Selection',
              subItems: []
            },
          ],
          // position: {
          //   ...currentVariablesValue.position,
          //   left: `${parseInt(currentVariablesValue.position.left.split('px')[0]) + 108}px`
          // }
        };

        // Update the control with the new value
        variablesArray.at(vIndex).patchValue(updatedVariablesValue);
        variablesCopyArray.at(vIndex).patchValue(updatedVariablesCopyValue);
        this.VariableSubMenu = [];
      }).catch((err) => {
        console.log(err)
      })
    } else if(selectedOption.name == 'Chat History Selection') {
      
      let chatMessages = currentVariablesValue.historyOptions[2].subItems[0].chatData.find((chatItem: any) => {
        return chatItem.id == selectedOption.id
      });

      let chatDocs: any = [];
      if(chatMessages?.uploaded_attachments?.length > 0) {
        chatMessages.uploaded_attachments.forEach((item: any) => {
          chatDocs.push(item)
        })
      }

      const updatedVariablesValue = {
        ...currentVariablesValue, // Keep existing values
        tags: [...currentVariablesValue.tags, {tag_name: selectedOption.question, tag_url: ''}],
        // varGptData: gptData,
        chatVar: {chat_id: selectedOption.id, chat_name: selectedOption.menuName?.trim()},
        chatHistoryDocs: [...currentVariablesValue.chatHistoryDocs, ...chatDocs],
        varGptData: '@@@ ' + selectedOption.question.trim()+ ' chat history retrieved.',
        // tags: [...currentVariablesValue.tags, selectedOption.question],
        // offset: 432,
        // historyFlowStates: 'semi-completed',
        historyOptions: [
          {
            enabled: false,
            grayedout: true,
            name: 'Chat History'
          },
          {
            enabled: false, 
            grayedout: true,
            name: 'Prompts', 
            subItems: [...currentVariablesValue.historyOptions[1].subItems]
          },
          {
            enabled: false, 
            grayedout: true,
            name: 'Chat History Selection', 
            subItems: [...currentVariablesValue.historyOptions[2].subItems]
          },
          {
            enabled: true, 
            grayedout: false,
            name: 'Chat Output Selection',
            subItems: [{
              menuName: 'All chats', 
              name: 'Chat Output Selection', 
              type: 'all',
              data: {
                selectedChat: selectedOption,
                chats: currentVariablesValue.historyOptions[2].subItems
              }
            }, 
            {menuName: 'custom', 
              name: 'Chat Output Selection', 
              type: 'custom',
              data: {
                selectedChat: selectedOption,
                chats: currentVariablesValue.historyOptions[2].subItems
              }
            }],
            // data: {
            //   selectedChat: selectedOption,
            //   chats: currentVariablesValue.historyOptions[2].subItems
            // }
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'From Input Document', 
            subItems: []
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Page Selection',
            subItems: []
          },
        ],
        // position: {
        //   ...currentVariablesValue.position,
        //   left: `${currentVariablesValue.offset}px`
        // }
        // position: {
        //   ...currentVariablesValue.position,
        //   left: `${parseInt(currentVariablesValue.position.left.split('px')[0]) + 200}px`
        // }
      };

      // Update only the specified key
      const updatedVariablesCopyValue = {
        ...currentVariablesCopyValue, // Keep existing values
        tags: [...currentVariablesCopyValue.tags, {tag_name: selectedOption.question, tag_url: ''}],
        // varGptData: gptData,
        chatVar: {chat_id: selectedOption.id, chat_name: selectedOption.menuName?.trim()},
        chatHistoryDocs: [...currentVariablesCopyValue.chatHistoryDocs, ...chatDocs],
        varGptData: '@@@ ' + selectedOption.question.trim()+ ' chat history retrieved.',
        // tags: [...currentVariablesCopyValue.tags, selectedOption.question],
        // offset: 432,
        // historyFlowStates: 'completed',
        // historyFlowStates: 'semi-completed',
        historyOptions: [
          {
            enabled: false,
            grayedout: true,
            name: 'Chat History'
          },
          {
            enabled: false, 
            grayedout: true,
            name: 'Prompts', 
            subItems: [...currentVariablesCopyValue.historyOptions[1].subItems]
          },
          {
            enabled: false, 
            grayedout: true,
            name: 'Chat History Selection', 
            subItems: [...currentVariablesCopyValue.historyOptions[2].subItems]
          },
          {
            enabled: true, 
            grayedout: false,
            name: 'Chat Output Selection',
            subItems: [{
              menuName: 'All chats', 
              name: 'Chat Output Selection', 
              type: 'all',
              data: {
                selectedChat: selectedOption,
                chats: currentVariablesCopyValue.historyOptions[2].subItems
              }
            }, 
            {menuName: 'custom', 
              name: 'Chat Output Selection', 
              type: 'custom',
              data: {
                selectedChat: selectedOption,
                chats: currentVariablesCopyValue.historyOptions[2].subItems
              }
            }],
            // data: {
            //   selectedChat: selectedOption,
            //   chats: currentVariablesValue.historyOptions[2].subItems
            // }
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'From Input Document', 
            subItems: []
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Page Selection',
            subItems: []
          },
        ],
        // position: {
        //   ...currentVariablesCopyValue.position,
        //   left: `${currentVariablesCopyValue.offset}px`
        // }
        // position: {
        //   ...currentVariablesCopyValue.position,
        //   left: `${parseInt(currentVariablesCopyValue.position.left.split('px')[0]) + 200}px`
        // }
      };

      // Update the control with the new value
      variablesArray.at(vIndex).patchValue(updatedVariablesValue);
      variablesCopyArray.at(vIndex).patchValue(updatedVariablesCopyValue);
      this.VariableSubMenu = [];
      // this.updateInputPromptText(tabIndex);
      // this.isVariableScrollable = true;
    } else if(selectedOption.name == "Chat Output Selection") {
      // Update only the specified key
      const updatedVariablesValue = {
        ...currentVariablesValue, // Keep existing values
        showPopup: false,
        // tags: [...currentVariablesValue.tags, selectedOption.type == 'all' ? 'All chats' : null],
        historyFlowStates: selectedOption.type == 'all' ? 'completed' : 'inprogress',
        chatSelectionType: selectedOption.type,
        tags: [...currentVariablesValue.tags, ...(selectedOption.type === 'all' ? [{tag_name: 'All chats', tag_url: ''}] : [])],
        inputVal: "",
        chatVar: {...currentVariablesValue.chatVar, messages_selected: [], label_name: selectedOption.type == 'all' ? `@@@ ${selectedOption.data.selectedChat.menuName.replace('\n', '').trim('')} chat history retrieved.` : ''},
        varGptData: selectedOption.type == 'all' ? '@@@ ' + selectedOption.data.selectedChat.question.trim()+ ' chat history retrieved.' : currentVariablesValue.varGptData,
        // tags: [
        //   ...currentVariablesValue.tags,
        //   ...(selectedOption.type === 'all' ? ['All chats'] : [])
        // ],
        // offset: 432,
      };

      // Update only the specified key
      const updatedVariablesCopyValue = {
        ...currentVariablesCopyValue, // Keep existing values
        showPopup: false,
        // tags: [...currentVariablesCopyValue.tags, selectedOption.type == 'all' ? 'All chats' : null],
        historyFlowStates: selectedOption.type == 'all' ? 'completed' : 'inprogress',
        chatSelectionType: selectedOption.type,
        tags: [...currentVariablesCopyValue.tags, ...(selectedOption.type === 'all' ? [{tag_name: 'All chats', tag_url: ''}] : [])],
        inputVal: "",
        chatVar: {...currentVariablesCopyValue.chatVar, messages_selected: [], label_name: selectedOption.type == 'all'  ? `@@@ ${selectedOption.data.selectedChat.menuName.replace('\n', '').trim('')} chat history retrieved.` : ''},
        varGptData: selectedOption.type == 'all' ? '@@@ ' + selectedOption.data.selectedChat.question.trim()+ ' chat history retrieved.' : currentVariablesCopyValue.varGptData,
        // tags: [
        //   ...currentVariablesCopyValue.tags,
        //   ...(selectedOption.type === 'all' ? ['All chats'] : [])
        // ],
        // offset: 432,
      };

      // Update the control with the new value
      variablesArray.at(vIndex).patchValue(updatedVariablesValue);
      variablesCopyArray.at(vIndex).patchValue(updatedVariablesCopyValue);
      this.VariableSubMenu = [];
      this.isVariableScrollable = true;
      if(selectedOption.type == 'custom') {
        this.handlePartialChatSelection(selectedOption, vIndex, tabIndex);
      }
      this.updateInputPromptText(tabIndex);
    } else if(selectedOption.name == 'From Input Document') {
     
      const updatedVariablesValue = {
        ...currentVariablesValue, // Keep existing values
        tags: [...currentVariablesValue.tags, {tag_name: selectedOption.menuName, tag_url: selectedOption.file_url}],
        // tags: [selectedOption.menuName],
        // offset: 160,
        pdfDocData: {"file_name": selectedOption.menuName, 'selected_pages': [], 'label_name': '@@@ ' + selectedOption.menuName.replace('\n', '').trim('')+ ' extracted.'},
        varGptData: '@@@ ' + selectedOption.menuName.trim()+ ' extracted.',
        // historyFlowStates: 'semi-completed',
        historyFlowStates: 'inprogress',
        inputVal: "@",
        historyOptions: [
          {
            enabled: false,
            grayedout: false,
            name: 'Chat History'
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Prompts', 
            subItems: []
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Chat History Selection', 
            subItems: []
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Chat Output Selection',
            subItems: []
          },
          {
            enabled: false, 
            grayedout: true,
            name: 'From Input Document', 
            subItems: [...currentVariablesValue.historyOptions[4].subItems]
          },
          {
            enabled: true,
            grayedout: false,
            name: 'Page Selection',
            subItems: [{
              menuName: 'All pages', 
              name: 'Page Selection', 
              type: 'all'},
              {
                menuName: 'Custom', 
                name: 'Page Selection', 
                type: 'custom'
              }
            ]
          },
        ],
        // position: {
        //   ...currentVariablesValue.position,
        //   left: `${parseInt(currentVariablesValue.position.left.split('px')[0]) + 160}px`
        // }
      };

      // Update only the specified key
      const updatedVariablesCopyValue = {
        ...currentVariablesCopyValue, // Keep existing values
        tags: [...currentVariablesCopyValue.tags, {tag_name: selectedOption.menuName, tag_url: selectedOption.file_url}],
        // tags: [selectedOption.menuName],
        // offset: 160,
        pdfDocData: {"file_name": selectedOption.menuName, 'selected_pages': [], 'label_name': '@@@ ' + selectedOption.menuName.replace('\n', '').trim('')+ ' extracted.'},
        varGptData: '@@@ ' + selectedOption.menuName.trim()+ ' extracted.',
        historyFlowStates: 'inprogress',
        // historyFlowStates: 'semi-completed',
        inputVal: "@",
        historyOptions: [
          {
            enabled: false,
            grayedout: false,
            name: 'Chat History'
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Prompts', 
            subItems: []
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Chat History Selection', 
            subItems: []
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Chat Output Selection',
            subItems: []
          },
          {
            enabled: false, 
            grayedout: true,
            name: 'From Input Document', 
            subItems: [...currentVariablesCopyValue.historyOptions[4].subItems]
          },
          {
            enabled: true,
            grayedout: false,
            name: 'Page Selection',
            subItems: [{
              menuName: 'All pages', 
              name: 'Page Selection', 
              type: 'all'},
              {
                menuName: 'Custom', 
                name: 'Page Selection', 
                type: 'custom'
              }
            ]
          },
        ],
        // position: {
        //   ...currentVariablesCopyValue.position,
        //   left: `${parseInt(currentVariablesCopyValue.position.left.split('px')[0]) + 160}px`
        // }
      };

      // Update the control with the new value
      variablesArray.at(vIndex).patchValue(updatedVariablesValue);
      variablesCopyArray.at(vIndex).patchValue(updatedVariablesCopyValue);
      this.VariableSubMenu = [];
      this.updateInputPromptText(tabIndex);
      // this.isVariableScrollable = true;
    } else if(selectedOption.name == 'Page Selection') {
      
      // Update only the specified key
      const updatedVariablesValue = {
        ...currentVariablesValue, // Keep existing values
        historyFlowStates: selectedOption.type == 'all' ? 'completed' : 'inprogress',
        tags: [...currentVariablesValue.tags, ...(selectedOption.type === 'all' ? [{tag_name: 'All pages', tag_url: ''}] : [{tag_name: 'Page Selection', tag_url: ''}])],
        pdfDocData: {...currentVariablesValue.pdfDocData, 'selected_pages': []},
        varGptData: selectedOption.type == 'all' ? '@@@ ' + currentVariablesValue.pdfDocData.file_name.trim()+ ' extracted.' : '',
        // tags: [
        //   ...currentVariablesValue.tags,
        //   ...(selectedOption.type === 'all' ? ['All pages'] : ['Page Selection'])
        // ],
        showPopup: false,
        // tags: [...currentVariablesValue.tags, 'Page Selection'],
        // offset: 432,
        inputVal: ""
      };

      // Update only the specified key
      const updatedVariablesCopyValue = {
        ...currentVariablesCopyValue, // Keep existing values
        historyFlowStates: selectedOption.type == 'all' ? 'completed' : 'inprogress',
        tags: [...currentVariablesCopyValue.tags, ...(selectedOption.type === 'all' ? [{tag_name: 'All pages', tag_url: ''}] : [{tag_name: 'Page Selection', tag_url: ''}])],
        pdfDocData: {...currentVariablesCopyValue.pdfDocData, 'selected_pages': []},
        varGptData: selectedOption.type == 'all' ? '@@@ ' + currentVariablesValue.pdfDocData.file_name.trim()+ ' extracted.' : '',
        // tags: [
        //   ...currentVariablesCopyValue.tags,
        //   ...(selectedOption.type === 'all' ? ['All pages'] : ['Page Selection'])
        // ],
        showPopup: false,
        // tags: [...currentVariablesCopyValue.tags, 'Page Selection'],
        // offset: 432,
        inputVal: ""
      };

      // Update the control with the new value
      variablesArray.at(vIndex).patchValue(updatedVariablesValue);
      variablesCopyArray.at(vIndex).patchValue(updatedVariablesCopyValue);
      this.VariableSubMenu = [];
      if(selectedOption.type == 'custom') {
        this.handleShowVariablePageSelection(currentVariablesCopyValue.position, vIndex);
      } else {
        this.isVariableScrollable = true;
      }
      this.updateInputPromptText(tabIndex);
    }
  }

  chatHistorySelectionData: {question: string,answer: string}[] = [];
  handlePartialChatSelection(chatData: any, vIndex: number, tabIndex: number) {
    const variablesArray = this.tabs[tabIndex].myForm.get('variables') as FormArray;
    const variablesCopyArray = this.tabs[tabIndex].myForm.get('variablesCopy') as FormArray;

    // Get the current control value
    const currentVariablesValue = variablesArray.at(vIndex).value;
    const currentVariablesCopyValue = variablesCopyArray.at(vIndex).value;

    
    let chatMessages = chatData.data.chats[0].chatData.find((chatItem: any) => {
      return chatItem.id == chatData.data.selectedChat.id
    });
   
    if(chatMessages.messages.length > 0) {
      let transChatMessages = chatMessages.messages.flatMap(({message_id, question, answer}: {message_id: number, question: string, answer: string}) => [
        {
          message_id: message_id,
          message_text: question.trim(),
          type: 'question'
        },
        {
          message_id: message_id,
          message_text: answer.trim(),
          type: 'answer'
        }
      ])

      let chatSelectionData = transChatMessages.map((item: any) => {
          // const message_text = marked(item.message_text);
          const message_text = marked(this.escapeNonHtmlTags(item.message_text).replace(/\[\^\d+\^\]/g, ''));
          const safe_message_text =
            message_text instanceof Promise
              ? message_text
                  .then((htmlString: string) =>
                    this.htmlToPlainText(htmlString)
                  )
                  .catch((error) => {
                    console.error(
                      "Error processing async markdown:",
                      error
                    );
                    return null;
                  })
              : this.htmlToPlainText(message_text);
          return {
            message_id: item.message_id,
            message_text: safe_message_text,
            type: item.type
          }
          // const chatQuest = marked(item.question);
          // const chatAnswer = marked(item.answer);

          // const safeQuest =
          //   chatQuest instanceof Promise
          //     ? chatQuest
          //         .then((htmlString: string) =>
          //           this.htmlToPlainText(htmlString)
          //         )
          //         .catch((error) => {
          //           console.error(
          //             "Error processing async markdown:",
          //             error
          //           );
          //           return null;
          //         })
          //     : this.htmlToPlainText(chatQuest);

          // const safeAnswer =
          //   chatAnswer instanceof Promise
          //     ? chatAnswer
          //         .then((htmlString: string) =>
          //           this.htmlToPlainText(htmlString)
          //         )
          //         .catch((error) => {
          //           console.error(
          //             "Error processing async markdown:",
          //             error
          //           );
          //           return null;
          //         })
          //     : this.htmlToPlainText(chatAnswer);
                
        // return {
        //   question: safeQuest,
        //   answer: chatAnswer,
        //   message_id: item.message_id
        // }
        
      })

      const dialogRef = this.dailog.open(ChatHistorySelectionComponent, {
        data: {
          chatData: chatSelectionData,
          selectedQuestion: chatData.data.selectedChat.question
        },
      });
      
      dialogRef.afterClosed().subscribe((res) => {

        if(res?.type == 'submitted' && res?.selectedChatData?.length > 0) {
          
          let gptData = ''
          let msg_selected: any = []
          res?.selectedChatData.forEach((item: any) => {
            // gptData += item.question + '<br>' + item.answer
            // msg_selected.push(item.message_id)

            gptData += item.message_text

            msg_selected = msg_selected.map((msg: any) =>
              msg.id == item.message_id ? { ...msg, [item.type]: true } : msg
            );
            
            // If the message_id doesn't exist, add it
            if (!msg_selected.some((msg: any) => msg.id == item.message_id)) {
              msg_selected.push({
                id: item.message_id,
                question: item.type === 'question',
                answer: item.type === 'answer'
              });
            }
          })
          const updatedVariablesValue = {
            ...currentVariablesValue, // Keep existing values
            varGptData: gptData,
            // tags: [...currentVariablesValue.tags, `${res?.selectedChatData?.length} chat output selected`],
            tags: [...currentVariablesValue.tags, {tag_name: `${res?.selectedChatData?.length} chat output selected`, tag_url: ''}],
            historyFlowStates: 'completed',
            inputVal: "",
            chatVar: {...currentVariablesValue.chatVar, messages_selected: msg_selected},
          };
    
          // Update only the specified key
          const updatedVariablesCopyValue = {
            ...currentVariablesCopyValue, // Keep existing values
            varGptData: gptData,
            // tags: [...currentVariablesValue.tags, `${res?.selectedChatData?.length} chat output selected`],
            tags: [...currentVariablesCopyValue.tags, {tag_name: `${res?.selectedChatData?.length} chat output selected`, tag_url: ''}],
            historyFlowStates: 'completed',
            inputVal: "",
            chatVar: {...currentVariablesCopyValue.chatVar, messages_selected: msg_selected},
          };
    
          // Update the control with the new value
          variablesArray.at(vIndex).patchValue(updatedVariablesValue);
          variablesCopyArray.at(vIndex).patchValue(updatedVariablesCopyValue);
          this.updateInputPromptText(tabIndex);
          this.isVariableScrollable = true;
          
        } else if(res?.type == 'cancled') {
          console.log('cancled')
        }
      });

      // Detect backdrop click and close manually
      // dialogRef.backdropClick().subscribe(() => {

      //   dialogRef.close();
      // });

      // chatMessages.messages.map((item: any) => {
      //   this.chatHistorySelectionData.push({
      //     question: item.question,
      //     answer: item.answer
      //   })
      // })
    }
  }

  @ViewChildren('tagsContainerWrapper') tagsContainerWrappers!: QueryList<ElementRef>;
  // @ViewChildren('tagsContainer') tagsContainers!: QueryList<ElementRef>;
  @ViewChildren('tagElement') tags!: QueryList<ElementRef>;
  inputOffset: number = 0;
  updateInputOffset() {
    const variablesArray = this.tabs[this.promptUserService.stepperPosition()].myForm.get('variables') as FormArray;
    const variablesCopyArray = this.tabs[this.promptUserService.stepperPosition()].myForm.get('variablesCopy') as FormArray;

    setTimeout(() => {
      const wrapperRef = this.tagsContainerWrappers.toArray()[this.promptUserService.stepperPosition()];
      if (!wrapperRef) return; // Ensure the wrapper exists

      // Get only the tagsContainers inside the specified wrapper
      // const containersInWrapper = wrapperRef.nativeElement.querySelectorAll('[tagsContainer]');
      const containersInWrapper = wrapperRef.nativeElement.querySelectorAll('.tagsContainer');

      containersInWrapper.forEach((containerRef: HTMLElement, index: number) => {
          // Get only the tags inside the current container
          // const tagsInContainer = containerRef.querySelectorAll('[tagElement]');
          const tagsInContainer = containerRef.querySelectorAll('.tag');

          const totalWidth = Array.from(tagsInContainer).reduce(
            (sum, tag) => sum + (tag as HTMLElement).offsetWidth + 5,
            0
          );

          if (variablesArray.at(index).value?.tags) {
              

              const updatedVariablesValue = {
                  ...variablesArray.at(index).value,
                  offset: totalWidth
              };

              const updatedVariablesCopyValue = {
                  ...variablesCopyArray.at(index).value,
                  offset: totalWidth
              };

              variablesArray.at(index).patchValue(updatedVariablesValue);
              variablesCopyArray.at(index).patchValue(updatedVariablesCopyValue);
          }
      });
      

      // Get the input element
      const inputElement = containersInWrapper[this.activeVarIndex].querySelectorAll('.mat-mdc-input-element')[0];

      // Check if the element exists
      if (inputElement) {
        // Create a KeyboardEvent for 'keyup' with '@' as the key
        const keyupEvent = new KeyboardEvent('keyup', { key: '@' });

        // Dispatch the event on the input element
        inputElement.dispatchEvent(keyupEvent);

 
      }
      
    }, 100);
  }

  showVariablePageSelection: boolean = false;
  pageSelectionTooltipStyles: { top: string; left: string } = { top: '0px', left: '0px' };
  vpageSelectionIndex: any;
  handleShowVariablePageSelection(position: any, index: number) {
    this.showVariablePageSelection = true;
    this.pageSelectionTooltipStyles = position
    this.vpageSelectionIndex = index
  }

  handlePageSelection(ele: HTMLInputElement, vIndex: number, tabIndex: number) {
    const variablesArray = this.tabs[tabIndex].myForm.get('variables') as FormArray;
    const variablesCopyArray = this.tabs[tabIndex].myForm.get('variablesCopy') as FormArray;

    // Get the current control value
    const currentVariablesValue = variablesArray.at(vIndex).value;
    const currentVariablesCopyValue = variablesCopyArray.at(vIndex).value;

    let pageInput = ele.value.trim();
    
    if (pageInput.length === 0) {
        this.openSnackbar('Please enter page no. (Eg 2,3,9-12)', 'An error occurred', 'error-snackbar');
        return;
    }

    let pageNumbers: number[] = [];
    let isValid = true;

    for (let item of pageInput.split(',')) {
      // let num = parseInt(item.trim(), 10);

      item = item.trim();
      if (item.includes('-')) {
        if(item[0] == '-') {
          this.openSnackbar('Please enter valid page numbers (Eg 2,3,9-12)', 'An error occurred', 'error-snackbar');
          pageNumbers = []; // Clear the array
          isValid = false;
          break; // Stop processing further
        }
        const [start, end] = item.split('-').map(Number);

        if (isNaN(start) || isNaN(end) || start == 0 || end == 0) {
          this.openSnackbar('Please enter valid page numbers (Eg 2,3,9-12)', 'An error occurred', 'error-snackbar');
          pageNumbers = []; // Clear the array
          isValid = false;
          break; // Stop processing further
        }

        for (let i = start; i <= end; i++) {
            pageNumbers.push(i);
        }
      } else {
        let num = Number(item.trim());
        if(Math.sign(num) == -1) {
          this.openSnackbar('Please enter valid page numbers (Eg 2,3,9-12)', 'An error occurred', 'error-snackbar');
          pageNumbers = []; // Clear the array
          isValid = false;
          break;
        }
        if (isNaN(num) || item.trim() == "" || num == 0) {
            this.openSnackbar('Please enter valid page numbers (Eg 2,3,9-12)', 'An error occurred', 'error-snackbar');
            pageNumbers = []; // Clear the array
            isValid = false;
            break; // Stop processing further
        }
        pageNumbers.push(num);
      }

      // let num = Number(item.trim());
      // if (isNaN(num) || item.trim() == "") {
      //     this.openSnackbar('Please enter valid page numbers (Eg 2,3)', 'error', 'error-snackbar');
      //     pageNumbers = []; // Clear the array
      //     isValid = false;
      //     break; // Stop processing further
      // }
      // pageNumbers.push(num);
    }

    if (isValid) {
     
      const updatedVariablesValue = {
        ...currentVariablesValue, // Keep existing values
        pdfDocData: {'file_name': currentVariablesValue.pdfDocData.file_name, 'selected_pages': pageNumbers, 'label_name': ''},
        // tags: [currentVariablesValue.tags[0], `Page's ${pageInput}`],
        tags: [currentVariablesValue.tags[0], {tag_name: `Page's ${pageInput}`, tag_url: ''}],
        historyFlowStates: 'completed',
        inputVal: ""
      };

      // Update only the specified key
      const updatedVariablesCopyValue = {
        ...currentVariablesCopyValue, // Keep existing values
        pdfDocData: {'file_name': currentVariablesCopyValue.pdfDocData.file_name, 'selected_pages': pageNumbers, 'label_name': ''},
        // tags: [currentVariablesCopyValue.tags[0], `Page's ${pageInput}`],
        tags: [currentVariablesCopyValue.tags[0], {tag_name: `Page's ${pageInput}`, tag_url: ''}],
        historyFlowStates: 'completed',
        inputVal: ""
      };

      // Update the control with the new value
      variablesArray.at(vIndex).patchValue(updatedVariablesValue);
      variablesCopyArray.at(vIndex).patchValue(updatedVariablesCopyValue);
      this.showVariablePageSelection = false;
      this.isVariableScrollable = true;
      this.updateInputPromptText(tabIndex);
     
    }
  }

  closePageSelection(ele: HTMLInputElement, vIndex: number, tabIndex: number) {
    this.showVariablePageSelection = false
    const variablesArray = this.tabs[tabIndex].myForm.get('variables') as FormArray;
    const variablesCopyArray = this.tabs[tabIndex].myForm.get('variablesCopy') as FormArray;

    // Get the current control value
    const currentVariablesValue = variablesArray.at(vIndex).value;
    const currentVariablesCopyValue = variablesCopyArray.at(vIndex).value;

    const updatedVariablesValue = {
      ...currentVariablesValue, // Keep existing values
      tags: [...currentVariablesValue.tags].slice(0, -1)
    };

    // Update only the specified key
    const updatedVariablesCopyValue = {
      ...currentVariablesCopyValue, // Keep existing values
      tags: [...currentVariablesCopyValue.tags].slice(0, -1)
    };

    // Update the control with the new value
    variablesArray.at(vIndex).patchValue(updatedVariablesValue);
    variablesCopyArray.at(vIndex).patchValue(updatedVariablesCopyValue);
    this.isVariableScrollable = true;
  }

  VariableSubMenu: any = []
  tooltipStyles: { top: string; left: string } = { top: '0px', left: '0px' };
  showVariableSubMenu(subMenu: any, event: MouseEvent): void {
    this.VariableSubMenu = subMenu;
    const windowInnerHeight = window.innerHeight;
    const target = event.target as HTMLElement;
    const rect = target.getBoundingClientRect();

    let subMenuHeightThrottle = 0;
    if(subMenu.length == 1) {
      subMenuHeightThrottle = 42;
    } else if(subMenu.length == 2) {
      subMenuHeightThrottle = 84;
    } else if(subMenu.length == 3) {
      subMenuHeightThrottle = 126;
    } else if(subMenu.length == 4) {
      subMenuHeightThrottle = 168;
    } else {
      subMenuHeightThrottle = 200;
    }
    

    let varCardPosition = (windowInnerHeight - rect.top) - subMenuHeightThrottle;
    let transVarCardTopPosition: number = 0;
    if(varCardPosition < 0) {
      transVarCardTopPosition = rect.top - Math.abs(varCardPosition) - 10;
    } else {
      transVarCardTopPosition = rect.top + 2
    }

    this.tooltipStyles = {
      top: `${transVarCardTopPosition}px`,
      left: `${rect.left + 213}px` // Position to the right of the hovered element
    };
  }

  handleRemoveTag(event: any, vIndex: number, tabIndex: number) {
    const variablesArray = this.tabs[tabIndex].myForm.get('variables') as FormArray;
    const variablesCopyArray = this.tabs[tabIndex].myForm.get('variablesCopy') as FormArray;

    const inputElement = event.target as HTMLInputElement;
    const cursorPosition = inputElement.selectionStart;

    if ((event.key === 'Backspace' || event.key === 'Delete') && cursorPosition === 0 && variablesCopyArray.at(vIndex).value.tags.length > 0) {

      const currentVariablesValue = variablesArray.at(vIndex).value;
      const currentVariablesCopyValue = variablesCopyArray.at(vIndex).value;

      let updatedVariablesValue: any = {};
      let updatedVariablesCopyValue: any = {};
      
      if(currentVariablesValue.historyOptions[1].enabled  && currentVariablesValue.tags.length == 1) {
        variablesArray.setControl(vIndex, this.fb.control(currentVariablesValue.label));
      } else if(currentVariablesValue.historyOptions[2].enabled  && currentVariablesValue.tags.length == 2) {
        updatedVariablesValue = {
          ...currentVariablesValue,
          showPopup: true,
          tags: [...currentVariablesValue.tags].slice(0, -1),
          inputVal: '@',
          historyOptions: [
            {
              enabled: false,
              grayedout: true,
              name: 'Chat History'
            },
            {
              enabled: true, 
              grayedout: false,
              name: 'Prompts', 
              subItems: [...currentVariablesValue.historyOptions[1].subItems]
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Chat History Selection', 
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Chat Output Selection',
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'From Input Document', 
              subItems: []
            },
            {
              enabled: false,
              grayedout: false,
              name: 'Page Selection',
              subItems: []
            },
          ],
          // offset: 120,
          // position: {
          //   ...currentVariablesValue.position,
          //   left: `${parseInt(currentVariablesValue.position.left.split('px')[0]) - 120}px`
          // }  
        }
        variablesArray.at(vIndex).patchValue(updatedVariablesValue);
        this.isVariableScrollable = false;
      } else if(currentVariablesValue.historyOptions[3].enabled  && currentVariablesValue.tags.length == 3) {
        updatedVariablesValue = {
          ...currentVariablesValue,
          historyFlowStates: 'inprogress',
          showPopup: true,
          tags: [...currentVariablesValue.tags].slice(0, -1),
          inputVal: '@',
          chatHistoryDocs: [],
          historyOptions: [
            {
              enabled: false,
              grayedout: true,
              name: 'Chat History'
            },
            {
              enabled: false, 
              grayedout: true,
              name: 'Prompts', 
              subItems: [...currentVariablesValue.historyOptions[1].subItems]
            },
            {
              enabled: true, 
              grayedout: false,
              name: 'Chat History Selection', 
              subItems: [...currentVariablesValue.historyOptions[2].subItems]
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Chat Output Selection',
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'From Input Document', 
              subItems: []
            },
            {
              enabled: false,
              grayedout: false,
              name: 'Page Selection',
              subItems: []
            },
          ],
          // offset: 228,
          // position: {
          //   ...currentVariablesValue.position,
          //   left: `${parseInt(currentVariablesValue.position.left.split('px')[0])}px`
          // }
        }
        variablesArray.at(vIndex).patchValue(updatedVariablesValue);
        this.isVariableScrollable = false;
      } else if(currentVariablesValue.historyOptions[3].enabled  && currentVariablesValue.tags.length == 4) {
        updatedVariablesValue = {
          ...currentVariablesValue,
          historyFlowStates: 'inprogress',
          showPopup: true,
          tags: [...currentVariablesValue.tags].slice(0, -1),
          inputVal: '@',
          historyOptions: [
            {
              enabled: false,
              grayedout: true,
              name: 'Chat History'
            },
            {
              enabled: false, 
              grayedout: true,
              name: 'Prompts', 
              subItems: [...currentVariablesValue.historyOptions[1].subItems]
            },
            {
              enabled: false, 
              grayedout: true,
              name: 'Chat History Selection', 
              subItems: [...currentVariablesValue.historyOptions[2].subItems]
            },
            {
              enabled: true, 
              grayedout: false,
              name: 'Chat Output Selection',
              subItems: [...currentVariablesValue.historyOptions[3].subItems]
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'From Input Document', 
              subItems: []
            },
            {
              enabled: false,
              grayedout: false,
              name: 'Page Selection',
              subItems: []
            },
          ],
          // offset: 228,
          // position: {
          //   ...currentVariablesValue.position,
          //   left: `${parseInt(currentVariablesValue.position.left.split('px')[0])}px`
          // }
        }
        variablesArray.at(vIndex).patchValue(updatedVariablesValue);
        this.isVariableScrollable = false;
      } else if(currentVariablesValue.historyOptions[4].enabled  && currentVariablesValue.tags.length == 1) {
        variablesArray.setControl(vIndex, this.fb.control(currentVariablesValue.label));
      } else if(currentVariablesValue.historyOptions[5].enabled  && currentVariablesValue.tags.length == 1) {
        variablesArray.setControl(vIndex, this.fb.control(currentVariablesValue.label));
      } else if(currentVariablesValue.historyOptions[5].enabled  && currentVariablesValue.tags.length == 2) {
        updatedVariablesValue = {
          ...currentVariablesValue,
          historyFlowStates: 'inprogress',
          showPopup: true,
          tags: [...currentVariablesValue.tags].slice(0, -1),
          inputVal: '@',
          historyOptions: [
            {
              enabled: false,
              grayedout: false,
              name: 'Chat History'
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Prompts', 
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Chat History Selection', 
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Chat Output Selection',
              subItems: []
            },
            {
              enabled: false, 
              grayedout: true,
              name: 'From Input Document', 
              subItems: [...currentVariablesValue.historyOptions[4].subItems]
            },
            {
              enabled: true,
              grayedout: false,
              name: 'Page Selection',
              subItems: [...currentVariablesValue.historyOptions[5].subItems]
            },
          ],
          position: {
            ...currentVariablesValue.position,
            left: `${parseInt(currentVariablesValue.position.left.split('px')[0])}px`
          }
        }
        variablesArray.at(vIndex).patchValue(updatedVariablesValue);
        this.showVariablePageSelection = false;
        this.isVariableScrollable = false;
      }
      
      if(currentVariablesCopyValue.historyOptions[1].enabled && currentVariablesCopyValue.tags.length == 1) {
        variablesCopyArray.setControl(vIndex, this.fb.control(""));
      } else if(currentVariablesCopyValue.historyOptions[2].enabled && currentVariablesCopyValue.tags.length == 2) {
        updatedVariablesCopyValue = {
          ...currentVariablesCopyValue,
          showPopup: true,
          tags: [...currentVariablesCopyValue.tags].slice(0, -1),
          inputVal: '@',
          historyOptions: [
            {
              enabled: false,
              grayedout: true,
              name: 'Chat History'
            },
            {
              enabled: true, 
              grayedout: false,
              name: 'Prompts', 
              subItems: [...currentVariablesValue.historyOptions[1].subItems]
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Chat History Selection', 
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Chat Output Selection',
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'From Input Document', 
              subItems: []
            },
            {
              enabled: false,
              grayedout: false,
              name: 'Page Selection',
              subItems: []
            },
          ],
          // offset: 120,
          // position: {
          //   ...currentVariablesValue.position,
          //   left: `${parseInt(currentVariablesValue.position.left.split('px')[0]) - 120}px`
          // } 
        }
        variablesCopyArray.at(vIndex).patchValue(updatedVariablesCopyValue);
        this.isVariableScrollable = false;
      } else if(currentVariablesCopyValue.historyOptions[3].enabled && currentVariablesCopyValue.tags.length == 3) {
        updatedVariablesCopyValue = {
          ...currentVariablesCopyValue,
          historyFlowStates: 'inprogress',
          showPopup: true,
          tags: [...currentVariablesCopyValue.tags].slice(0, -1),
          inputVal: '@',
          chatHistoryDocs: [],
          historyOptions: [
            {
              enabled: false,
              grayedout: true,
              name: 'Chat History'
            },
            {
              enabled: false, 
              grayedout: true,
              name: 'Prompts', 
              subItems: [...currentVariablesValue.historyOptions[1].subItems]
            },
            {
              enabled: true, 
              grayedout: false,
              name: 'Chat History Selection', 
              subItems: [...currentVariablesValue.historyOptions[2].subItems]
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Chat Output Selection',
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'From Input Document', 
              subItems: []
            },
            {
              enabled: false,
              grayedout: false,
              name: 'Page Selection',
              subItems: []
            },
          ],
          // offset: 228,
          // position: {
          //   ...currentVariablesValue.position,
          //   left: `${parseInt(currentVariablesValue.position.left.split('px')[0])}px`
          // }
        }
        variablesCopyArray.at(vIndex).patchValue(updatedVariablesCopyValue);
        this.isVariableScrollable = false;
      } else if(currentVariablesCopyValue.historyOptions[3].enabled && currentVariablesCopyValue.tags.length == 4) {
        updatedVariablesCopyValue = {
          ...currentVariablesCopyValue,
          historyFlowStates: 'inprogress',
          showPopup: true,
          tags: [...currentVariablesCopyValue.tags].slice(0, -1),
          inputVal: '@',
          historyOptions: [
            {
              enabled: false,
              grayedout: true,
              name: 'Chat History'
            },
            {
              enabled: false, 
              grayedout: true,
              name: 'Prompts', 
              subItems: [...currentVariablesValue.historyOptions[1].subItems]
            },
            {
              enabled: false, 
              grayedout: true,
              name: 'Chat History Selection', 
              subItems: [...currentVariablesValue.historyOptions[2].subItems]
            },
            {
              enabled: true, 
              grayedout: false,
              name: 'Chat Output Selection',
              subItems: [...currentVariablesValue.historyOptions[3].subItems]
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'From Input Document', 
              subItems: []
            },
            {
              enabled: false,
              grayedout: false,
              name: 'Page Selection',
              subItems: []
            },
          ],
          // offset: 228,
          // position: {
          //   ...currentVariablesValue.position,
          //   left: `${parseInt(currentVariablesValue.position.left.split('px')[0])}px`
          // }
        }
        variablesCopyArray.at(vIndex).patchValue(updatedVariablesCopyValue);
        this.isVariableScrollable = false;
      } else if(currentVariablesValue.historyOptions[4].enabled) {
        variablesCopyArray.setControl(vIndex, this.fb.control(currentVariablesValue.label));
      } else if(currentVariablesCopyValue.historyOptions[5].enabled  && currentVariablesCopyValue.tags.length == 1) {
        variablesCopyArray.setControl(vIndex, this.fb.control(""));
      } else if(currentVariablesCopyValue.historyOptions[5].enabled  && currentVariablesCopyValue.tags.length == 2) {
        updatedVariablesCopyValue = {
          ...currentVariablesCopyValue,
          historyFlowStates: 'inprogress',
          showPopup: true,
          tags: [...currentVariablesCopyValue.tags].slice(0, -1),
          inputVal: '@',
          historyOptions: [
            {
              enabled: false,
              grayedout: false,
              name: 'Chat History'
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Prompts', 
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Chat History Selection', 
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Chat Output Selection',
              subItems: []
            },
            {
              enabled: false, 
              grayedout: true,
              name: 'From Input Document', 
              subItems: [...currentVariablesCopyValue.historyOptions[4].subItems]
            },
            {
              enabled: true,
              grayedout: false,
              name: 'Page Selection',
              subItems: [...currentVariablesCopyValue.historyOptions[5].subItems]
            },
          ],
          position: {
            ...currentVariablesCopyValue.position,
            left: `${parseInt(currentVariablesCopyValue.position.left.split('px')[0])}px`
          }
        }
        variablesCopyArray.at(vIndex).patchValue(updatedVariablesCopyValue);
        this.showVariablePageSelection = false;
        this.isVariableScrollable = false;
      }

      this.VariableSubMenu = [];
    }

    if ((event.key === 'Backspace' || event.key === 'Delete') && cursorPosition === 1 && variablesCopyArray.at(vIndex).value.showPopup) {
      

      const currentVariablesValue = variablesArray.at(vIndex).value;
      const currentVariablesCopyValue = variablesCopyArray.at(vIndex).value;
      const updatedVariablesValue = {
        ...currentVariablesValue,
        inputVal: '',
        showPopup: false,
      }
      const updatedVariablesCopyValue = {
        ...currentVariablesCopyValue,
        inputVal: '',
        showPopup: false,
      }

      variablesArray.at(vIndex).patchValue(updatedVariablesValue);
      variablesCopyArray.at(vIndex).patchValue(updatedVariablesCopyValue);
      this.VariableSubMenu = [];
      this.isVariableScrollable = true;
    }

    if ((event.key === 'Backspace' || event.key === 'Delete') && cursorPosition === 1 && variablesCopyArray.at(vIndex).value.tags.length == 0 && event.target.value == '@')   {
      const currentVariablesValue = variablesArray.at(vIndex).value;
      variablesArray.setControl(vIndex, this.fb.control(currentVariablesValue.label));
      variablesCopyArray.setControl(vIndex, this.fb.control(""));
    }
  }

  updateInputPromptText(tabPositionIndex: number) {

    const variablesCopyArray = this.tabs[tabPositionIndex].myForm.get('variablesCopy') as FormArray;
    let updatedText = this.promptDataEditedVal != "" ? this.promptDataEditedVal : this.tabs[tabPositionIndex].myForm.value.promptDetails;
    let matcheVal: [string] = updatedText.match(/\[\[(.*?)\]\]/g);
    let matches;
    if(matcheVal) {
      matches = matcheVal.map((match) => {
        return match.slice(1, -1); // Remove [ ]
      });
    }

    if (matches) {
      matches.forEach((match, index) => {
        //const newVal = Array.isArray(this.promptVariables[index]) ? `[${(this.promptVariables[index] as string[]).join('/')}]`
        //: this.promptVariables[index];

        //temp if
        if (variablesCopyArray.at(index)) {
          const newVal = Array.isArray(variablesCopyArray.at(index).value) ? `[${(variablesCopyArray.at(index).value as string[]).join('/')}]`
            : variablesCopyArray.at(index).value;
          // updatedText = updatedText.replace(match, `${newVal}`);
          if(Array.isArray(variablesCopyArray.at(index).value)) {
            updatedText = updatedText.replace(`[${match}]`, `<span class="var-text">[${newVal}]</span>`);
          } else if((typeof(variablesCopyArray.at(index).value) == 'object' && 
                    (variablesCopyArray.at(index).value?.historyFlowStates == 'completed' || 
                    variablesCopyArray.at(index).value?.historyFlowStates == 'semi-completed'))) {
              let var_type: string = "";
              let chatSelectionType = newVal?.chatSelectionType == 'all' ? 'allChat' : 'partialChat'
              if(Object.keys(newVal.pdfDocData).length > 0) {
                var_type = 'doc'
              } else {
                var_type = 'chat'
              }
              updatedText = updatedText.replace(`[${match}]`, `<span class="var-text ${var_type} ${chatSelectionType}">${newVal.varGptData}</span>`)
          } else {
              updatedText = updatedText.replace(`[${match}]`, `<span class="var-text">${newVal}</span>`);
          }
        } else {
          updatedText = updatedText.replace(match, ``);
        }

      })
    }

    this.tabs[tabPositionIndex].myForm.patchValue({
      gptQuestion: updatedText
    })
  }

  onVariableFocus(v: any, event: FocusEvent, i: number, label: string) {
    setTimeout(() => {
        this.onVariableChange(v, event, false, i, label);
    }, 0);
  }

  // Check if the variable is a string or array
  isString(variable: any): boolean {
    return typeof variable === 'string'
  }

  isArray(variable: any): boolean {
    return Array.isArray(variable)
  }
  
  isObject(variable: any): boolean {
    return typeof variable === 'object' && variable !== null && Object.keys(variable).length > 0
  }

   openSnackbar(message: string, title: string, cssClass: string) {
      // this.snackBar.openFromComponent(SnackBarComponent, {
      //   data: { message: message, type: type },
      //   duration: 3000, // Duration in milliseconds,
      //   horizontalPosition: 'center',
      //   verticalPosition: 'top',
      //   panelClass: [cssClass],
      // });
       const dialogRef = this.dialog.open(ErrorNotficationComponent, {
                     data: {
                       message: message,
                       title: title,
                       action_type: 'add',
                       cssClass: cssClass
                     }
                   });
    }

  isDragOver = false;
  onDragOver(event: any, uploadType: string, index: number) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: any, uploadType: string, index: number) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onDrop(event: any, uploadType: string, index: number) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;


    if (event.dataTransfer?.files) {
      const droppedFiles = Array.from(event.dataTransfer.files);
     
      this.onFileChange(event, uploadType, index)
    }
  }

  onFileChange(event: any, uploadType: string, index: number) {
    //debugger;
    // const {files} = event.target;

    // for (let i = 0; i < files.length; i++) {
    //   this.attachments.push(files[i].name);
    // }

    type AttachmentType = {
      file_type: string;
      index: number;
      selected: File;
      page_number: string;
    }[];
    let get_file_extension_re = /(?:\.([^.]+))?$/;
    const selectedFiles = event.target.files || event.dataTransfer.files;

    if (selectedFiles) {
      //const selectedFiles = event.target.files;
      for (let i = 0; i < selectedFiles.length; i++) {
        // if (uploadType === 'permanentAttachment') {

        //   let permanentAttachmentDup: AttachmentType = this.tabs[index].myForm.value.perminentAttachment || [];
        //   if (permanentAttachmentDup.length > 0) {
        //     if (
        //       permanentAttachmentDup.some(
        //         (existingFile) => existingFile.selected.name === selectedFiles[i]?.name
        //       )
        //     ) {
        //       //alert(`Duplicate permanent attachment: ${selectedFiles[i]?.name}`);
        //       this.openSnackbar("Duplicate prompt attachment: " + selectedFiles[i]?.name, 'error', 'error-snackbar')
        //       break;
        //     } else {
        //       let file_extension: string = get_file_extension_re.exec(selectedFiles[i].name)?.[1] || "";
        //       permanentAttachmentDup.push({ "selected": selectedFiles[i], "index": index, "file_type": file_extension, "page_number": "" })
        //       this.tabs[index].myForm.patchValue({
        //         perminentAttachment: permanentAttachmentDup
        //       });
        //       this.perminentAttachments.push({ "selected": selectedFiles[i], "index": index, "file_type": file_extension });
        //     }
        //   } else {
        //     let file_extension: string = get_file_extension_re.exec(selectedFiles[i].name)?.[1] || "";

        //     const newAttachment = {
        //       selected: selectedFiles[i],
        //       index: index,
        //       file_type: file_extension,
        //     };
        //     const updatedAttachments = [newAttachment];
        //     this.tabs[index].myForm.patchValue({
        //       perminentAttachment: updatedAttachments
        //     });
        //     this.perminentAttachments.push(newAttachment)
        //   }

        //   // this.perminentAttachments.push(selectedFiles); prev commented

        // }
        
        //if(selectedFiles[i]?.type === 'application/pdf'){
          if (uploadType === 'otherAttachment') {
            let otherAttachmentDup: AttachmentType = this.attachmentTabs[index].attachmentForm.value.otherAttachment || [];
            if (otherAttachmentDup.length > 0) {
              if (
                otherAttachmentDup.some(
                  (existingFile) => existingFile.selected.name === selectedFiles[i]?.name
                )
              ) {
                this.openSnackbar("Duplicate prompt attachment: " + selectedFiles[i]?.name, 'An error occurred', 'error-snackbar')
                break;
              } else {
                let file_extension: string = get_file_extension_re.exec(selectedFiles[i].name)?.[1] || "";
                otherAttachmentDup.push({ "selected": selectedFiles[i], "index": otherAttachmentDup.length + 1, "file_type": file_extension, "page_number": "" })
                this.attachmentTabs[index].attachmentForm.patchValue({
                  otherAttachment: otherAttachmentDup
                });
                //this.perminentAttachments.push({ "selected": selectedFiles[i], "index": index, "file_type": file_extension });
              }
            } else {
              let file_extension: string = get_file_extension_re.exec(selectedFiles[i].name)?.[1] || "";

              const newAttachment = {
                selected: selectedFiles[i],
                index: otherAttachmentDup.length + 1,
                file_type: file_extension,
                page_number: ""
              };
              const updatedAttachments = [newAttachment];
              this.attachmentTabs[index].attachmentForm.patchValue({
                otherAttachment: updatedAttachments
              });
              //this.perminentAttachments.push(newAttachment)
            }

          }

          if (uploadType === 'perminentAttachments') {
          
            //this.promptUserDetails
            let permanent_attachment=this.promptUserDetails?.prompt_details[index].permanent_attachments;

            let permanentAttachmentDup: AttachmentType = this.attachmentTabs[index].attachmentForm.value.permanentAttachments || [];
            
            if (permanentAttachmentDup.length > 0 || permanent_attachment.length>0) {
              if (
                permanentAttachmentDup.some(
                  (existingFile) => existingFile.selected.name === selectedFiles[i]?.name
                ) || permanent_attachment.some( (existingFile:any) => existingFile === selectedFiles[i]?.name)
              ) {
                this.openSnackbar("Duplicate prompt attachment: " + selectedFiles[i]?.name, 'An error occurred', 'error-snackbar')
                break;
              } else {
                let file_extension: string = get_file_extension_re.exec(selectedFiles[i].name)?.[1] || "";
                permanentAttachmentDup.push({ "selected": selectedFiles[i], "index": permanentAttachmentDup.length + 1, "file_type": file_extension, "page_number": "" })
                this.attachmentTabs[index].attachmentForm.patchValue({
                  permanentAttachments: permanentAttachmentDup
                });
                //this.perminentAttachments.push({ "selected": selectedFiles[i], "index": index, "file_type": file_extension });
              }
            } else {
              let file_extension: string = get_file_extension_re.exec(selectedFiles[i].name)?.[1] || "";

              const newAttachment = {
                selected: selectedFiles[i],
                index: permanentAttachmentDup.length + 1,
                file_type: file_extension,
                page_number: ""
              };
              const updatedAttachments = [newAttachment];
              this.attachmentTabs[index].attachmentForm.patchValue({
                permanentAttachments: updatedAttachments
              });
           
            
            }


          
            // let permaAttachmentDup: AttachmentType = this.attachmentTabs[index].attachmentForm.value.otherAttachment || [];
            // if (otherAttachmentDup.length > 0) {
            //   if (
            //     otherAttachmentDup.some(
            //       (existingFile) => existingFile.selected.name === selectedFiles[i]?.name
            //     )
            //   ) {
            //     this.openSnackbar("Duplicate prompt attachment: " + selectedFiles[i]?.name, 'error', 'error-snackbar')
            //     break;
            //   } else {
            //     let file_extension: string = get_file_extension_re.exec(selectedFiles[i].name)?.[1] || "";
            //     otherAttachmentDup.push({ "selected": selectedFiles[i], "index": otherAttachmentDup.length + 1, "file_type": file_extension, "page_number": "" })
            //     this.attachmentTabs[index].attachmentForm.patchValue({
            //       otherAttachment: otherAttachmentDup
            //     });
            //     //this.perminentAttachments.push({ "selected": selectedFiles[i], "index": index, "file_type": file_extension });
            //   }
            // } else {
            //   let file_extension: string = get_file_extension_re.exec(selectedFiles[i].name)?.[1] || "";

            //   const newAttachment = {
            //     selected: selectedFiles[i],
            //     index: otherAttachmentDup.length + 1,
            //     file_type: file_extension,
            //     page_number: ""
            //   };
            //   const updatedAttachments = [newAttachment];
            //   this.attachmentTabs[index].attachmentForm.patchValue({
            //     otherAttachment: updatedAttachments
            //   });
            //   //this.perminentAttachments.push(newAttachment)
            // }

          }
        //} else {
        //  this.openSnackbar('Only PDF files are allowed', 'An error occurred', 'error-snackbar')
        //}

      }
      
    }
    this.promptModified.set(true);

    // this.promptUserService.changeData(this.attachments);
    // this.otherAttachmentsContainer?.nativeElement.scrollIntoView({
    //   behavior: 'smooth',
    //   block: 'end'
    // });
    
  }

  deleteFile(attachment_index: number, fileType: string, tabIndex: number, filename?: string) {
    type AttachmentType = {
      file_type: string;
      index: number;
      selected: File;
      page_number: string;
    }
    
    if(fileType == "otherAttachment") {
      let tempperment: any[] = [];
      tempperment = this.attachmentTabs[tabIndex].attachmentForm.value.otherAttachment.filter((file: AttachmentType) => {
        return file.selected.name != filename
      })

      this.attachmentTabs[tabIndex].attachmentForm.patchValue({
        otherAttachment: tempperment
      });
    }

    if(fileType == "perminentAttachments") {
      
      let tempperment: any[] = [];
      tempperment = this.attachmentTabs[tabIndex].attachmentForm?.value?.permanentAttachments?.filter((file: AttachmentType) => {
        return file.selected.name != filename
      })

      

      this.attachmentTabs[tabIndex].attachmentForm.patchValue({
        permanentAttachments: tempperment
      });
    }

    if(fileType == "permanentAttachments"){
     
      
      const attachments = this.promptUserDetails?.prompt_details[tabIndex]?.permanent_attachments || [];

      // Remove the element by name
        this.promptUserDetails.prompt_details[tabIndex].permanent_attachments = attachments.filter(
           (attachment: string) => attachment !== filename
        );
    }
  }
  
  toggleExpansion() {
    this.isExpansion = !this.isExpansion
  }


  togglePromptExpansion() {
    this.isPromptExpansion = !this.isPromptExpansion
  }

  onSubmitClick(event: any) {

  }

  loadChats(item: any, showSidePanel: boolean, index?:any) {
    
    let chatMessages = this.chatHistoryData.find((chatItem: any) => {
      this.SELECTED_CHAT_HISTORY_ID = item.chat_id;
      return chatItem.id == item.chat_id
    });
    if (chatMessages) {
      this.chatId = chatMessages.id;
      this.currChatId.set({chat_id: chatMessages.id, message_id: ""});
      this.messages = [];
      this.msg[index]=[];     

      chatMessages.uploaded_attachments.forEach((file: any) => {
        this.messages.push({
          type: "file",
          value: file.file_name,
          isPrompt: true,
          page_number: "",
          question: '',
        });
      });

      chatMessages.messages.forEach((messageItem: any) => {
        this.messages.push({
          type: "text",
          value: this.template_converted?messageItem.question:this.escapeNonHtmlTags(messageItem.question),//messageItem.question,
          isPrompt: true,
          question: ''
        });
        this.messages.push({
          type: "text",
          value: messageItem.answer,
          isPrompt: false,
          question: messageItem.question,
          citations: messageItem.citations
        });
      });
      if(showSidePanel) {
        this.toggleSidebar();
      }
      this.enableChatPrompt = true;
      this.msg[index]=this.messages;
                                                                              
      //if(index != undefined){
        this.renderBotMsg(this.msg[index]);
      //}
      // else{
      //   this.renderBotMsg(this.messages);
      // }
     
    }
  }

  async downloadFile(file: any, type: any, prompt_id: any, prompt_title: any, prompt_detail_id: any): Promise<void> {
     try {
       const fileName = file; // Default file name
 
      
       const presSignedUrlRequest = {
         prompt_id: prompt_id,
         title: prompt_title,
         url_type: 'get_object',
         prompt_detail_id: prompt_detail_id,
         attachment_type: "permanent_attachments",//"prompt_attachments",
         file_name: fileName,
         user_id:this.userid
       }
 
       const response = await this.promptCreateService.getPresignedUrl(presSignedUrlRequest).toPromise();
 
 
       if (response?.data?.url) {
         const fileUrl = response.data.url;
        
         // Fetch the file as a blob
         const fileResponse = await fetch(fileUrl);
         const blob = await fileResponse.blob();
 
         // Create a temporary anchor element for downloading the file
         const anchor = document.createElement('a');
         const objectUrl = URL.createObjectURL(blob);
         anchor.href = objectUrl;
         anchor.download = fileName;
 
         // Trigger the download
         anchor.click();
 
         // Release the object URL to free memory
         URL.revokeObjectURL(objectUrl);
         } else {
           console.error('Failed to get presigned URL');
         }
     
         } catch (error: any) {
           console.error('An error occurred while fetching the URL:', error);
       }
     }


  convertToList(data: any) {
    if (data) {
      const bulletLines = data.split('\n').filter((line: any) => line.trim() !== '');
      return bulletLines;
    }
  }

  expandedTextarea: string | null = null;
  expandedTextTitle: string | null = null;
  isTextareaExpanded: boolean = false;
  onPromptEditHandler(event: Event, title: string, selector: string) {
    this.expandedTextarea = selector;
    this.expandedTextTitle = title;
    this.isTextareaExpanded = true;
  }

  onPromptEditCloseHandler() {
    this.expandedTextarea = "";
    this.expandedTextTitle = "title";
    this.isTextareaExpanded = false;

    this.adjustHeight(this.promptUserService.stepperPosition());
  }

  showTooltip(tooltip: string) {
    if(tooltip == 'prompt-tooltip') {
      this.showPromptInstruction = true
    } else if(tooltip == 'var-tooltip') {
      this.showTooltipInstruction = true;
    } else if(tooltip == 'version'){
      this.showVersionInstruction = true;
      
    }
  }
  hideTooltio(tooltip: string) {
    if(tooltip == 'prompt-tooltip') {
      this.showPromptInstruction = false
    } else if(tooltip == 'var-tooltip') {
      this.showTooltipInstruction = false;
    } else if(tooltip == 'version'){
      this.showVersionInstruction = false;
      

    }
  }

  @HostListener('document:click', ['$event'])
  onOutsideClick(event: MouseEvent) {
    const target_ele = event.target as HTMLElement;

    if (this.citationTooltipVisible && !target_ele.closest('.citation-tooltip')) {
      this.citationTooltipVisible = false;
    }

    if(!target_ele.closest('.moreOptionsIcon') && this.promptUserService.stepperPosition() != null) {
      this.isChatContainerScrollable = true;
      this.selectedChatIndex = null;
    }

    if (!this.tabs.length) return;
    
    const variablesArray = this.tabs[this.promptUserService.stepperPosition()].myForm.get('variables') as FormArray;
    const variablesCopyArray = this.tabs[this.promptUserService.stepperPosition()].myForm.get('variablesCopy') as FormArray;

    // Get the current control value
    const currentVariablesValue = variablesArray?.at(this.activeVarIndex)?.value;
    const currentVariablesCopyValue = variablesCopyArray?.at(this.activeVarIndex)?.value;
    
    const targetElement = event.target as HTMLElement;

    if (currentVariablesCopyValue?.showPopup && !targetElement.closest('.mat-mdc-card')) {
      const updatedVariablesValue = {
        ...currentVariablesValue,
        showPopup: false,
        inputVal: ''
      }
      const updatedVariablesCopyValue = {
        ...currentVariablesCopyValue,
        showPopup: false,
        inputVal: ''
      }

      variablesArray.at(this.activeVarIndex).patchValue(updatedVariablesValue);
      variablesCopyArray.at(this.activeVarIndex).patchValue(updatedVariablesCopyValue);
      this.isVariableScrollable = true;
      this.VariableSubMenu = [];
    }

    if(currentVariablesValue?.tags?.length == 0  && !targetElement.closest('.mat-mdc-card')) {
      variablesArray.setControl(this.activeVarIndex, this.fb.control(currentVariablesValue.label));
      variablesCopyArray.setControl(this.activeVarIndex, this.fb.control(""));
    }

    if (this.showVariablePageSelection && !targetElement.closest('.mat-mdc-card')) {
      this.closePageSelection(this.pageInput, this.activeVarIndex, this.promptUserService.stepperPosition())
    }
  }

  // Renaming of ChatHistory
  selectedChatIndex: number | null = null;
  selectedChatItem: any;
  chatHistoryMoreOptionsPosition = { top: 0, left: 0 };
  chatHistoryRenameTimeout: any;
  chatHistoryPanelIndex: number = 0
  @ViewChildren('chatHistoryContainer') chatHistoryContainers!: QueryList<ElementRef>;
  isChatContainerScrollable =  true;

  showChatHistoryOptions(event: MouseEvent, index: number, chatPanelIndex: number, chat: any) {
      this.isChatContainerScrollable = false;
      this.selectedChatIndex = index;
      this.chatHistoryPanelIndex = chatPanelIndex;
      this.selectedChatItem = chat;
      this.chatHistoryMoreOptionsPosition = {
        top: event.clientY + 10,
        left: event.clientX - 10
      };
  }

  editChatName(chat: any, chatIndex: number) {
    this.isChatContainerScrollable = true;
    chat.isEdit = true;
    this.selectedChatIndex = null;

    // Auto-focus input after it appears in the DOM
    setTimeout(() => {
      const wrapperRef = this.chatHistoryContainers.toArray()[this.promptUserService.stepperPosition()];
      if (!wrapperRef) return; // Ensure the wrapper exists

      // Find all input fields with the class `.chatHistory-edit-input`
      const chatInputsWrap = wrapperRef.nativeElement.querySelectorAll('.history-body-wrap');
      const chatInputs = chatInputsWrap[this.chatHistoryPanelIndex].querySelectorAll('.history-item-body-content');
      // const chatInputs = wrapperRef.nativeElement.querySelectorAll('.history-item-body-content');

      // Select the correct input based on `chatIndex`
      const inputElement = chatInputs[chatIndex].getElementsByClassName('chatHistory-edit-input')[0] as HTMLElement;

      if (inputElement) {
        inputElement.focus();
      }
    }, 100);
  }

  startRenameTimer(event:any, chat: any) {
  
    clearTimeout(this.chatHistoryRenameTimeout);
    this.chatHistoryRenameTimeout = setTimeout(() => this.saveChatName(event, chat), 5000);
  }

  saveChatName(event:any, chat: any) {
    // Clear the rename timer to prevent duplicate calls
    clearTimeout(this.chatHistoryRenameTimeout);

    chat.isEdit = false;

    if(event.target.value.trim() == "") {
      // this.openSnackbar('Please rename Chat History', 'An error occurred', 'error-snackbar')
      return;
    }
    
    let prompt_id = this.promptUserDetails.prompt_id;
    let prompt_detail_version_id = this.promptUserDetails.prompt_details[this.selectedIndex].prompt_detail_id;
    let requestData = {
      "chat_id": chat.chat_id,
      "chat_name": event.target.value,
      "project_code": "1311_promptid",
      "prompt_id": prompt_id,
      "prompt_detail_version_id": prompt_detail_version_id,
      "is_prompt_saved_or_submitted": false,
    }

    this.promptCreateService.updateChatName(requestData).subscribe((res) => {
      if (res && res["status_code"] === 200) {
        this.fetchChats(prompt_id, prompt_detail_version_id);
        // this.openSnackbar('Chat History renamed successfully', 'Success message', 'success-snackbar')
      }
    });
  }
  
  ngOnDestroy(): void {
    this.clearPolling(); // Stop polling
  }
}